<style>
  .p-inputtext.ng-invalid.ng-touched {
    border-color: red !important;
  }

  .primaryEmail {
    border: 1px solid red;
  }

  .p-dropdown.ng-invalid.ng-touched:not(form)>div {
    border: 1px solid red;
  }
  .p-confirm-dialog .p-dialog-content {
    align-items: center;
    display: inline !important;
}
</style>
<p-toast position="bottom-center"></p-toast>
<p-dialog header="Success" [(visible)]="saveModal" [modal]="true" [style]="{width: '30vw'}" [draggable]="false"
  [closable]="false" [resizable]="false">
  <br>
 <div class="card p-m-2 p-p-2">
  <p class="text-center">Your details were saved successfully!</p>
  <p class="text-center">Please login using your email <strong>: {{emailId}}</strong> to complete the remaining information. </p>
 </div>
  <ng-template pTemplate="footer">
    <div class="text-center">
      <p-button icon="pi pi-check" style="height: 30px !important;" (click)="saveModal=false;saveRedirect();" label="Ok" styleClass="p-button-sm p-button-primary">
      </p-button>
    </div>    
  </ng-template>
</p-dialog>

<p-dialog header="Thank you for your submission" [(visible)]="submitModal" [modal]="true"
  [style]="{width: '50vw'}" [draggable]="false" [closable]="false" [resizable]="false">
  <p class="submit-text">Our administrator will verify your company details and respond once approved or provide further details.</p>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" (click)="submitModal=false;saveRedirect();" label="Ok" styleClass="p-button-text">
    </p-button>
  </ng-template>
</p-dialog>
<section>
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-1"></div>
      <div class="col-sm-10 p-0">
        <div class="card Title-bar-blue">
          <div class="devcare-card-header">
            <span class="devcare-sub-header Title-bar-text">Vendor Registration</span>
          </div>
          <div class="text-sm text-left">

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section>
  <form [formGroup]="registerProfileForm" novalidate>
    <div class="row">
      <div class="col-md-1">
      </div>
      <div class="col-md-10">
        <p-accordion>
          <p-accordionTab header="Company Profile" [selected]="true">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4" *ngIf=disableVendorName>
                    <label for="inputName" class="required">Entity Type<span class="required-field">*</span></label>
                    <p-dropdown (onChange)="getEntityTypeOnChange($event)" [options]="entityTypes" placeholder="Select"
                      optionLabel="description" [(ngModel)]="selectedEntityTypeId" [ngModelOptions]="{standalone: true}"
                      [disabled]=true>
                    </p-dropdown>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf=!disableVendorName>
                    <label for="inputName" class="required">Entity Type<span class="required-field">*</span></label>
                    <p-dropdown (onChange)="getEntityTypeOnChange($event)" [options]="entityTypes" placeholder="Select"
                      optionLabel="description" [(ngModel)]="selectedEntityTypeId"
                      [ngModelOptions]="{standalone: true}">
                    </p-dropdown>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf=disableVendorName>
                    <label for="vendorName">Vendor Name<span class="required-field">*</span></label>
                    <input class="form-control" id="disabled-input" maxlength="100" formControlName="vendorName"
                    [(ngModel)]="vendorNameOnMSADoc"
                    (keyup)="onVendorAvailabilityCheck()" maxlength="100" type="text" pInputText disabled />
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf=!disableVendorName>
                    <label for="vendorName">Vendor Name<span class="required-field">*</span></label>
                    <input class="form-control" id="disabled-input" maxlength="100" formControlName="vendorName"
                    [(ngModel)]="vendorNameOnMSADoc"
                    (keyup)="onVendorAvailabilityCheck();preventSqlComments($event)" maxlength="100" type="text"
                      pInputText />
                    <span class="text-danger"
                      *ngIf="(registerProfileFormControl.vendorName.touched) && registerProfileFormControl.vendorName.errors?.required">
                    </span>
                    <span class="text-danger" *ngIf="vendorNameAvail">
                      Vendor Name already exists
                    </span>
                    <span class="text-danger" *ngIf="isSqlComments">
                      Please enter a valid Vendor Name
                    </span>
                  </div>

                  <div class="p-field p-col-12 p-md-4">
                    <label for="taxIdNumber">Tax ID Number<span *ngIf="!forIndividual"
                        class="required-field">*</span></label>
                    <input type="text" class="form-control" formControlName="taxIdNumber"
                      (keyup)="onVendorAvailabilityCheck();onCheckTaxIdNumber()" mask='00-0000000' pInputText>
                    <span class="text-danger"
                      *ngIf="(registerProfileFormControl.taxIdNumber.touched) && registerProfileFormControl.taxIdNumber.errors?.required">
                      Please enter a valid TIN
                    </span>
                    <span class="text-danger"
                      *ngIf="(registerProfileFormControl.taxIdNumber.touched) && registerProfileFormControl.taxIdNumber.errors?.minlength">
                      Please enter a valid TIN
                    </span>
                    <span class="text-danger" *ngIf="taxIdAvail">
                     TIN is already in use
                    </span>
                  </div>

                </div>
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4" *ngIf=disableVendorEmail>
                    <label for="vendorEmailId">Email Address<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="vendorEmailId"
                      (keyup)="onVendorEmailAvailabilityCheck()" type="email" pInputText disabled>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf=!disableVendorEmail>
                    <label for="vendorEmailId">Email Address<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="vendorEmailId"
                      (keyup)="onVendorEmailAvailabilityCheck();onVendorAvailabilityCheck()" type="email" pInputText>
                    <span class="text-danger"
                      *ngIf="(registerProfileFormControl.vendorEmailId.touched) && registerProfileFormControl.vendorEmailId.errors?.required">
                    </span>
                    <span class="text-danger"
                      *ngIf="registerProfileFormControl.vendorEmailId.touched && registerProfileFormControl.vendorEmailId.errors?.email">
                      Please Enter a Valid Email Address
                    </span>
                    <span class="text-danger"
                      *ngIf="registerProfileFormControl.vendorEmailId.touched && registerProfileFormControl.vendorEmailId.errors?.pattern">
                      Please Enter a Valid Email Address
                    </span>
                    <span class="text-danger"
                      *ngIf="registerProfileForm?.controls?.vendorEmailId?.hasError('emailInvalid')">
                      Please Enter a Valid Email Address<br />
                    </span>
                    <span class="text-danger"
                      *ngIf="registerProfileForm?.controls?.vendorEmailId?.hasError('emailEntityInvalid')">
                      Please Enter your Business Email Address<br />
                    </span>
                    <span class="text-danger" *ngIf="vendorEmailAvail">
                      The Email is already in use
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="vendorPhoneNumber">Phone Number <span class="required-field">*</span></label>
                    <input type="text" class="form-control" formControlName="vendorPhoneNumber" mask='(000) 000-0000'
                      (keyup)="vendorPhoneUniqueNumbers($event)" pInputText>
                    <span class="text-danger" *ngIf="isVendorPhoneUniqueNumbers">
                      Please Enter Valid Phone Number
                    </span>
                    <span class="text-danger" *ngIf="isVendorPhoneNumberValid">
                      Please Enter Valid Phone Number
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf=vendorPhoneExtDisabled>
                    <label for="VendorExtNumber">Extension Number</label>
                    <input type="text" class="form-control" maxlength="6" formControlName="vendorPhoneExtNumber"
                      (keypress)="onlyNumbers($event)" pInputText disabled>
                    <span class="text-danger"
                      *ngIf="registerProfileFormControl.vendorPhoneExtNumber.touched && registerProfileFormControl.vendorPhoneExtNumber.errors?.pattern">
                      Please Enter Valid Ext Number
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf=!vendorPhoneExtDisabled>
                    <label for="VendorExtNumber">Extension Number</label>
                    <input type="text" class="form-control" maxlength="6" formControlName="vendorPhoneExtNumber"
                      (keypress)="onlyNumbers($event)" pInputText>
                    <span class="text-danger"
                      *ngIf="registerProfileFormControl.vendorPhoneExtNumber.touched && registerProfileFormControl.vendorPhoneExtNumber.errors?.pattern">
                      Please Enter Valid Ext Number
                    </span>
                  </div>
                 
                </div>
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="faxNumber">Fax Number </label>
                    <input type="text" class="form-control" formControlName="faxNumber" mask='(000) 000-0000'
                      (keyup)="faxUniqueNumbers($event)" pInputText>
                    <span class="text-danger" *ngIf="isFaxUniqueNumbers">
                      Please Enter Valid Fax Number
                    </span>
                    <span class="text-danger" *ngIf="isFaxNumberValid">
                      Please Enter Valid Fax Number
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="webAddress">Web Address</label>
                    <input type="text" class="form-control" maxlength="100" formControlName="webAddress" pInputText>
                    <!-- <span class="text-danger"
                      *ngIf="(registerProfileFormControl.webAddress.touched) && registerProfileFormControl.webAddress.errors?.required">
                    </span> -->
                    <span class="text-danger"
                      *ngIf="(registerProfileFormControl.webAddress.touched) && registerProfileFormControl.webAddress.errors?.pattern">
                      Please enter a valid Web Address
                    </span>
                  </div>
                
                  <div class="p-field p-col-12 p-md-4">
                    <label for="addressLine1">Address Line 1<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="addressLine1"
                    [(ngModel)]="addressOnMSADoc"
                     type="text" pInputText>
                    <span class="text-danger"
                      *ngIf="(registerProfileFormControl.addressLine1.touched) && registerProfileFormControl.addressLine1.errors?.required">
                    </span>
                  </div>

                </div>
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="addressLine2">Address Line 2</label>
                    <input class="form-control" maxlength="100" formControlName="addressLine2" maxlength="100"
                    [(ngModel)]="address2OnMSADoc" 
                    type="text" pInputText>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="city">City<span class="required-field">*</span></label>
                    <input type="text" class="form-control" maxlength="100" formControlName="city" 
                    [(ngModel)]="cityOnMSADoc"
                    pInputText>
                  </div>
                 
                  <div class="p-field p-col-12 p-md-4">
                    <label for="state">State<span class="required-field">*</span></label>
                    <p-dropdown (onChange)="getStateOnChange($event)" placeholder="Select a State"
                      [(ngModel)]="selectedStateId" [ngModelOptions]="{standalone: true}" [options]="states"
                      optionLabel="stateName">
                    </p-dropdown>
                  </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-2">
                    <label for="zipCode">Zip Code<span class="required-field">*</span></label>
                    <input type="text" class="form-control" formControlName="zipCode" maxlength="5"
                    [(ngModel)]="zipCodeOnMSADoc"
                      (keypress)="onlyNumbers($event)" (keyup)="enableZipCodeExt()" pInputText preventCutCopyPaste>
                      <span class="text-danger"
                      *ngIf="(registerProfileFormControl.zipCode.touched) && registerProfileFormControl.zipCode.errors?.required">
                    </span>
                      <span class="text-danger"
                      *ngIf="(registerProfileFormControl.zipCode.touched) && registerProfileFormControl.zipCode.errors?.pattern">
                      Please enter valid zip code
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-2" *ngIf=!disabled>
                    <label for="zipCode">Zip Code Ext</label>
                    <input type="text" class="form-control" formControlName="zipCodeExt" maxlength="4"
                      (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                    <span class="text-danger"
                      *ngIf="(registerProfileFormControl.zipCodeExt.touched) && registerProfileFormControl.zipCodeExt.errors?.pattern">
                      Please enter valid zip code ext.
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-2" *ngIf=disabled>
                    <label for="zipCode">Zip Code Ext</label>
                    <input type="text" class="form-control" formControlName="zipCodeExt" maxlength="4"
                      (keypress)="onlyNumbers($event)" pInputText disabled>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="selectedCountry">Country<span class="required-field">*</span></label>
                    <p-dropdown id="selectedCountry" [options]="countries" optionLabel="name" [disabled]=true>
                    </p-dropdown>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="paymentTerms">Payment Terms<span class="required-field">*</span></label>
                    <p-dropdown (onChange)="getPaymentTermsOnChange($event)" placeholder="Select a Payment Term"
                      [(ngModel)]="selectedPaymentTermsId" [ngModelOptions]="{standalone: true}" [options]="paymentTerms"
                      optionLabel="description">
                    </p-dropdown>
                  </div>

                </div>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab [selected]="false">
            <ng-template pTemplate="header" class="font-accordion"><span style="font-family: Roboto,'system-ui',sans-serif;font-size: 17px;">Company Details</span> <span *ngIf="forIndividual"
                style="font-weight:400;font-style:oblique ; color: #007bff;"> - This section is optional for the
                Individual Entity</span></ng-template>
            <ng-template pTemplate="content">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-12">
                          <label for="companysKeyCapabilities">Company’s Key Capabilities<span *ngIf="!forIndividual"
                              class="required-field">*</span></label><br />
                          <p-editor formControlName="companysKeyCapabilities"
                            placeholder="Please list your Key Capabilities, Including Non-IT. What skill sets and / or solutions do you specialize in?"
                            [style]="{'height':'100px'}"></p-editor>
                          <span class="text-danger" *ngIf="this.registerProfileForm.controls?.companysKeyCapabilities?.hasError('maxlengthError')">
                            Only 10,000 characters allowed.
                          </span>
                        </div>
                      </div>

                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-12">
                          <label for="corporateHistory">Corporate History<span *ngIf="!forIndividual"
                              class="required-field">*</span></label><br />
                          <p-editor maxlength="10000" formControlName="corporateHistory"
                            placeholder="Please describe your company’s corporate history and its experience providing staff augmentation, Project/SOW, and BPO services."
                            [style]="{'height':'100px'}"></p-editor>
                            <span class="text-danger" *ngIf="this.registerProfileForm.controls?.corporateHistory?.hasError('maxlengthError')">
                              Only 10,000 characters allowed.
                            </span>
                        </div>
                      </div>

                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-6">
                          <label for="firstname">Company Establishment(Year)<span *ngIf="!forIndividual"
                              class="required-field">*</span></label>
                          <input class="form-control" maxlength="4" (keypress)="onlyNumbers($event)"
                            formControlName="companyEstablishment" type="text" preventCutCopyPaste pInputText>
                          <!-- <span class="text-danger"
                            *ngIf="(registerFormControl.firstName.touched) && registerFormControl.firstName.errors?.required">
                          </span> -->
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                          <label for="address">Business Certifications<span *ngIf="!forIndividual"
                              class="required-field">*</span></label>
                          <p-multiSelect appendTo="p-accordion-tab" [options]="businessCertifications" 
                            (onChange)="getBusinessCertificationsOnChange($event)" [(ngModel)]="businessCertIds"
                            [ngModelOptions]="{standalone: true}" defaultLabel="You may select multiple certifications"
                            optionLabel="description" display="chip"></p-multiSelect>
                        </div>
                      </div>
                      <!---->
                      <section>
                        <div formArrayName="onshoreFields">
                          <span class="text-md text-dark font-weight-bold">Headquarters/Branches&nbsp;
                            <button (click)="addOnshoreFields()" pButton pRipple type="button" icon="pi pi-plus"
                              class="p-button-rounded"></button>
                          </span>
                          <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-12">
                              <div class="p-fluid p-formgrid p-grid"
                                *ngFor="let control of registerProfileForm.controls.onshoreFields['controls']; let i=index;"
                                [formGroupName]="i">
                                <div class="p-field p-col-12 p-md-12">
                                  <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-12 p-md-3">
                                      <label for="bmContactName">Contact Name<span *ngIf="!forIndividual && i==0"
                                        class="required-field">*</span></label>
                                      <input type="text" class="form-control" maxlength="100"
                                        formControlName="contactName" pInputText>
                                        <span class="text-danger"
                                        *ngIf="(onshoreFields.controls[i].get('contactName').touched) &&  onshoreFields.controls[i].get('contactName').errors?.required">
                                      </span>
                                    </div>
                                    <div class="p-field p-col-12 p-md-2">
                                      <label for="bmPhone">Phone<span *ngIf="!forIndividual && i==0"
                                        class="required-field">*</span></label>
                                      <input type="text" class="form-control" formControlName="phone"
                                        mask='(000) 000-0000' (keyup)="onshorePhoneUniqueNumbers($event,i)" pInputText>
                                      <!-- <span class="text-danger" *ngIf="isOnshorePhoneNumberValid && (onshoreFields.controls[i].get('phone').touched)">
                                        Please Enter a Valid Phone Number
                                      </span>
                                     <span class="text-danger" *ngIf="isOnshorePhoneUniqueNumbers && (onshoreFields.controls[i].get('phone').touched)">
                                      Repeating Numbers Not Allowed
                                    </span> -->
                                      <span class="text-danger"
                                        *ngIf="(onshoreFields.controls[i].get('phone').touched) &&  onshoreFields.controls[i].get('phone').errors?.pattern">
                                        Please Enter a Valid Phone Number
                                      </span>
                                      <span class="text-danger"
                                        *ngIf="(onshoreFields.controls[i].get('phone').touched) && onshoreFields.controls[i].get('phone').errors?.minlength">
                                        Please Enter a Valid Phone Number
                                      </span>
                                      <span class="text-danger"
                                        *ngIf="(onshoreFields.controls[i].get('phone').touched) &&  onshoreFields.controls[i].get('phone').errors?.required">
                                      </span>
                                    </div>
                                    <div class="p-field p-col-12 p-md-3">
                                      <label for="bmOfficeCity">Office City / State<span *ngIf="!forIndividual && i==0"
                                        class="required-field">*</span></label>
                                      <input type="text" class="form-control" maxlength="100"
                                        formControlName="officeCityState" pInputText>
                                        <span class="text-danger"
                                        *ngIf="(onshoreFields.controls[i].get('officeCityState').touched) &&  onshoreFields.controls[i].get('officeCityState').errors?.required">
                                      </span>
                                    </div>
                                    <div class="p-field p-col-12 p-md-3">
                                      <label for="bmAddress">Address<span *ngIf="!forIndividual && i==0"
                                        class="required-field">*</span></label>
                                      <input type="text" class="form-control" maxlength="200" formControlName="address"
                                        pInputText>
                                        <span class="text-danger"
                                        *ngIf="(onshoreFields.controls[i].get('address').touched) &&  onshoreFields.controls[i].get('address').errors?.required">
                                      </span>
                                    </div>
                                    <div class="p-field p-col-12 p-md-1">
                                      <div class="p-d-flex p-jc-between">
                                        <button (click)="removeOnshoreFields(i)" pButton pRipple type="button"
                                          icon="pi pi-minus"
                                          class="p-button-rounded p-button-danger text-right"></button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <!---->
                      <section>
                        <span class="text-md text-dark font-weight-bold"> International Offices &nbsp;
                          <p-inputSwitch formControlName="offShoreToggle" (onChange)="onEnableOffshoreFields($event)">
                          </p-inputSwitch> &nbsp;
                          <button *ngIf="showOffShoreFields" (click)="addOffshoreFields(i)" pButton pRipple type="button" icon="pi pi-plus"
                            class="p-button-rounded"></button>
                        </span>
                        <div formArrayName="offshoreFields">

                          <div *ngIf="showOffShoreFields" class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-12">
                              <div class="p-fluid p-formgrid p-grid"
                                *ngFor="let control of registerProfileForm.controls.offshoreFields['controls']; let i=index;"
                                [formGroupName]="i">
                                <div class="p-field p-col-12 p-md-12">
                                  <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-12 p-md-3">
                                      <label for="bmAddress">Address</label>
                                      <input type="text" class="form-control" maxlength="200" formControlName="address"
                                        pInputText>
                                    </div>
                                    <div class="p-field p-col-12 p-md-2">
                                      <label for="bmCity">City</label>
                                      <input type="text" class="form-control" formControlName="city" maxlength="100"
                                        pInputText>
                                    </div>
                                    <div class="p-field p-col-12 p-md-3">
                                      <label for="bmState">State</label>
                                      <input type="text" class="form-control" maxlength="100" formControlName="state"
                                        pInputText>
                                    </div>
                                    <div class="p-field p-col-12 p-md-3">
                                      <label for="bmCountry">Country</label>
                                      <input type="text" class="form-control" maxlength="100" formControlName="country"
                                        pInputText>
                                    </div>
                                    <div class="p-field p-col-12 p-md-1">
                                      <div class="p-d-flex p-jc-between">
                                        <button (click)="removeOffshoreFields(i)" pButton pRipple type="button"
                                          icon="pi pi-minus" class="p-button-rounded p-button-danger"></button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </section>
                      <br>
                      <div class="p-fluid p-formgrid p-grid">

                        <div class="p-field p-col-12 p-md-12">
                          <label for="address">Awards and Certifications <span *ngIf="!forIndividual"
                              class="required-field">*</span></label>
                          <!-- <p-editor maxlength="5000" formControlName="awardsAndCertifications"
                            [style]="{'height':'100px'}"></p-editor> -->
                          <p-editor maxlength="5000" formControlName="awardsAndCertifications"
                            [style]="{'height':'100px'}"></p-editor>
                            <span class="text-danger" *ngIf="this.registerProfileForm.controls?.awardsAndCertifications?.hasError('maxlengthError')">
                              Only 5000 characters allowed.
                            </span>
                        </div>
                      </div>
                      <span class="text-md text-dark font-weight-bold">Company Revenue<span *ngIf="!forIndividual"
                          class="required-field">*</span></span>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-4">
                          <label for="alabama"> {{lastYear}}  Revenue <span *ngIf="!forIndividual"
                              class="required-field">*</span></label>
                          <input type="text" class="form-control" maxlength="100"
                            formControlName="companyRevenueLastYear" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-4">
                          <label for="alaska">{{last2YearBefore}} Revenue <span *ngIf="!forIndividual"
                              class="required-field">*</span></label>
                          <input type="text" class="form-control" maxlength="100"
                            formControlName="companyRevenue2YearsBefore" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-4">
                          <label for="arizona">{{last3YearBefore}}  Revenue <span *ngIf="!forIndividual"
                              class="required-field">*</span></label>
                          <input type="text" class="form-control" maxlength="100"
                            formControlName="companyRevenue3YearsBefore" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-6">
                          <label for="address">No. of W2 Employees<span *ngIf="!forIndividual"
                              class="required-field">*</span></label><br>
                          <input type="text" class="form-control" maxlength="4" formControlName="noofW2Employees"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                          <label for="">No. of 1099/C2C Consultant<span *ngIf="!forIndividual"
                              class="required-field">*</span></label><br>
                          <input type="text" class="form-control" maxlength="4" formControlName="noofC2CConsultant"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-12">
                          <label for="address"> Is your company registered in E-Verify?</label>&nbsp;
                          <p-inputSwitch formControlName="isEVerifyRegistered"> </p-inputSwitch>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                          <label for="">Does your company offer Affordable Care Act (ACA) compliant coverage to all of
                            your contract employees?</label>&nbsp;
                          <p-inputSwitch formControlName="isOfferACAAct"> </p-inputSwitch>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-7">
                          <label class="p-mr-1" for="address">Are you specialized in training OPT/CPT Students/H4 EAD employees?
                          </label>
                          <p-inputSwitch (onChange)="onEnableOPT($event)" formControlName="isOPTStudents">
                          </p-inputSwitch>
                        </div>
                        <div class="p-field p-col-12 p-md-5" *ngIf="showOPT">
                          <label for="">How many no. of trained candidates available?<span *ngIf="!forIndividual"
                              class="required-field">*</span></label>&nbsp;
                          <input type="text" class="form-control" maxlength="4"
                            formControlName="noofOPTCandidatesAvailable" (keypress)="onlyNumbers($event)" pInputText
                            preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-12" *ngIf="showOPT">
                          <label for="address">What technology do you train them?<span *ngIf="!forIndividual"
                              class="required-field">*</span></label>&nbsp;
                          <textarea formControlName="oPTTechnologyTrain" maxlength="500" pInputTextarea
                            class="form-control"></textarea>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-3">
                          <label for="address">Do you support TN Visa?</label>&nbsp;
                          <p-inputSwitch (onChange)="onEnableTNVisa($event)" formControlName="isSupportTNVisa">
                          </p-inputSwitch>
                        </div>
                        <div class="p-field p-col-12 p-md-5" *ngIf="showTNVisa">
                          <label for="address">Select Country<span *ngIf="!forIndividual"
                              class="required-field">*</span></label><br>
                          <p-multiSelect appendTo="p-accordion-tab" [options]="selectCountryVisa"
                            (onChange)="getSelectecdCountryVisaOnChange($event)" [(ngModel)]="selectedCountries"
                            [ngModelOptions]="{standalone: true}" defaultLabel={{selectedCountriesVisa}}
                            optionLabel="description"></p-multiSelect>
                        </div>
                        <div class="p-field p-col-12 p-md-4" *ngIf="showTNVisa">
                          <label for="address">No. of available TN visa candidates<span *ngIf="!forIndividual"
                              class="required-field">*</span></label><br>
                          <input type="text" class="form-control" maxlength="4" formControlName="noofTNVisaCandidates"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">

                        <div class="p-field p-col-12 p-md-12">
                          <label for="address"> What is the size of your available candidates on bench? <span
                              *ngIf="!forIndividual" class="required-field">*</span></label>
                          <p-editor maxlength="1000" formControlName="availableCandidateBench"
                            placeholder="Please provide the specialization roles along with the candidate count. Eg. Developers = 30, Business Analysts = 10"
                            [style]="{'height':'100px'}"></p-editor>
                            <span class="text-danger" *ngIf="this.registerProfileForm.controls?.availableCandidateBench?.hasError('maxlengthError')">
                              Only 1000 characters allowed.
                            </span>
                          <!-- <p-editor [style]="{'height':'320px'}"></p-editor>                                    -->
                        </div>
                      </div>
                      <span class="text-md text-dark font-weight-bold ">No. of candidates available in each state<span
                        *ngIf="!forIndividual" class="required-field">*</span></span>
                    <div class=" p-2 p-mt-2" style="height: 300px;overflow: scroll;border: none !important;">
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-2">
                          <label for="alabama"> Alabama </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="alabama"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="alaska">Alaska </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="alaska"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="arizona">Arizona</label>
                          <input type="text" class="form-control" maxlength="3" formControlName="arizona"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="arkansas">Arkansas </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="arkansas"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="california">California </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="california"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="colorado">Colorado </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="colorado"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-2">
                          <label for="connecticut"> Connecticut </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="connecticut"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="delaware">Delaware </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="delaware"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="florida">Florida</label>
                          <input type="text" class="form-control" maxlength="3" formControlName="florida"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="georgia">Georgia </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="georgia"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="hawaii">Hawaii </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="hawaii"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="idaho">Idaho </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="idaho"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-2">
                          <label for="illinois"> Illinois </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="illinois"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="indiana">Indiana </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="indiana"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="iowa">Iowa</label>
                          <input type="text" class="form-control" maxlength="3" formControlName="iowa"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="kansas">Kansas </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="kansas"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="kentucky">Kentucky </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="kentucky"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="louisiana">Louisiana</label>
                          <input type="text" class="form-control" maxlength="3" formControlName="louisiana"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-2">
                          <label for="maine"> Maine </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="maine"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="maryland">Maryland </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="maryland"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="massachusetts">Massachusetts</label>
                          <input type="text" class="form-control" maxlength="3" formControlName="massachusetts"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="michigan">Michigan </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="michigan"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="minnesota">Minnesota </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="minnesota"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="mississippi">Mississippi </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="mississippi"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-2">
                          <label for="missouri"> Missouri </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="missouri"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="montana">Montana </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="montana"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="nebraska">Nebraska</label>
                          <input type="text" class="form-control" maxlength="3" formControlName="nebraska"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="nevada">Nevada </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="nevada"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="newHampshire">New Hampshire </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="newHampshire"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="newJersey">New Jersey </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="newJersey"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-2">
                          <label for="newMexico"> New Mexico </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="newMexico"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="newYork">New York </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="newYork"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="northCarolina">North Carolina</label>
                          <input type="text" class="form-control" maxlength="3" formControlName="northCarolina"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="northDakota">North Dakota </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="northDakota"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="ohio">Ohio </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="ohio"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="oklahoma"> Oklahoma </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="oklahoma"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-2">
                          <label for="oregon"> Oregon </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="oregon"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="pennsylvania">Pennsylvania </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="pennsylvania"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="rhodeIsland">Rhode Island</label>
                          <input type="text" class="form-control" maxlength="3" formControlName="rhodeIsland"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="southCarolina"> South Carolina </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="southCarolina"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="southDakota">South Dakota</label>
                          <input type="text" class="form-control" maxlength="3" formControlName="southDakota"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="tennessee"> Tennessee </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="tennessee"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-2">
                          <label for="texas"> Texas </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="texas"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="utah"> Utah </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="utah"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="vermont">Vermont</label>
                          <input type="text" class="form-control" maxlength="3" formControlName="vermont"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="virginia">Virginia </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="virginia"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="washington">Washington </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="washington"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="westVirginia"> West Virginia </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="westVirginia"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-2">
                          <label for="texas"> Wisconsin </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="wisconsin"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                          <label for="utah"> Wyoming </label>
                          <input type="text" class="form-control" maxlength="3" formControlName="wyoming"
                            (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>

                </div>
              </div>
            </ng-template>
          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab [selected]="false">
            <ng-template pTemplate="header"><span style="font-family: Roboto,'system-ui',sans-serif;font-size: 17px;">Delivery Teams </span><span *ngIf="forIndividual"
                style="font-weight:400;font-style:oblique ; color: #007bff;"> - This section is optional for the
                Individual Entity</span></ng-template>
            <ng-template pTemplate="content">
              <div class="row">
                <div class="col-lg-12">
                  <!-- <span class="text-md text-dark font-weight-bold">Leadership and Recruiting Team(s)</span> -->
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                      <label for="address">Leadership and Recruiting Team(s)</label>
                      <p-editor maxlength="10000" formControlName="leadership" [style]="{'height':'100px'}"></p-editor>
                      <span class="text-danger" *ngIf="this.registerProfileForm.controls?.leadership?.hasError('maxlengthError')">
                        Only 10,000 characters allowed.
                      </span>
                    </div>
                  </div>
                  <span class="text-md text-dark font-weight-bold">Company Points of Contact</span><br>
                  <span class="text-md text-dark font-weight-bold">Owner / President </span>
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-1">

                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="ownerName">Name <span
                        *ngIf="!forIndividual" class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="ownerName" pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.ownerName.touched) && registerProfileFormControl.ownerName.errors?.required">
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="ownerTitle"> Title <span
                        *ngIf="!forIndividual" class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="ownerTitle" pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.ownerTitle.touched) && registerProfileFormControl.ownerTitle.errors?.required">
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="ownerEmail"> Email<span
                        *ngIf="!forIndividual" class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="ownerEmail" pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.ownerEmail.touched) && registerProfileFormControl.ownerEmail.errors?.required">
                      </span>
                      <span class="text-danger"
                        *ngIf="registerProfileFormControl.ownerEmail.touched && registerProfileFormControl.ownerEmail.errors?.pattern">
                        Please enter a valid email address
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="ownerPhone"> Phone<span
                        *ngIf="!forIndividual" class="required-field">*</span> </label>
                      <input type="text" class="form-control" formControlName="ownerPhone" mask='(000) 000-0000'
                        (keyup)="ownerPhoneUniqueNumbers($event)" pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.ownerPhone.touched) && registerProfileFormControl.ownerPhone.errors?.required">
                      </span>
                      <span class="text-danger" *ngIf="isOwnerPhoneUniqueNumbers">
                        Please Enter a Valid Phone Number
                      </span>
                      <span class="text-danger" *ngIf="isOwnerPhoneNumberValid">
                        Please Enter a Valid Phone Number
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="ownerPhone">Alternate Phone <span
                        *ngIf="!forIndividual" class="required-field">*</span></label>
                      <input type="text" class="form-control" formControlName="ownerAlternatePhone"
                        mask='(000) 000-0000' (keyup)="ownerAlternatePhoneUniqueNumbers($event)" pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.ownerAlternatePhone.touched) && registerProfileFormControl.ownerAlternatePhone.errors?.required">
                      </span>
                      <span class="text-danger" *ngIf="isOwnerAlternatePhoneUniqueNumbers">
                        Please Enter a Valid Phone Number
                      </span>
                      <span class="text-danger" *ngIf="isOwnerAlternatePhoneNumberValid">
                        Please Enter a Valid Phone Number
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-1">

                    </div>
                  </div>
                  <span class="text-md text-dark font-weight-bold">Recruiting / Delivery </span>
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-1">

                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="recruitingName">Name <span
                        *ngIf="!forIndividual" class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="recruitingName"
                        pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.recruitingName.touched) && registerProfileFormControl.recruitingName.errors?.required">
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="recruitingTitle">Title <span
                        *ngIf="!forIndividual" class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="recruitingTitle"
                        pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.recruitingTitle.touched) && registerProfileFormControl.recruitingTitle.errors?.required">
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="recruitingEmail">Email<span
                        *ngIf="!forIndividual" class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="recruitingEmail"
                        pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.recruitingEmail.touched) && registerProfileFormControl.recruitingEmail.errors?.required">
                      </span>
                      <span class="text-danger"
                        *ngIf="registerProfileFormControl.recruitingEmail.touched && registerProfileFormControl.recruitingEmail.errors?.pattern">
                        Please enter a valid email address
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="recruitingPhone">Phone <span
                        *ngIf="!forIndividual" class="required-field">*</span></label>
                      <input type="text" class="form-control" formControlName="recruitingPhone" mask='(000) 000-0000'
                        (keyup)="recruitingPhoneUniqueNumbers($event)" pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.recruitingPhone.touched) && registerProfileFormControl.recruitingPhone.errors?.required">
                      </span>
                      <span class="text-danger" *ngIf="isRecruitingPhoneUniqueNumbers">
                        Please Enter a Valid Phone Number
                      </span>
                      <span class="text-danger" *ngIf="isRecruitingPhoneNumberValid">
                        Please Enter a Valid Phone Number
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="recruitingAlternatePhone">Alternate Phone<span
                        *ngIf="!forIndividual" class="required-field">*</span> </label>
                      <input type="text" class="form-control" formControlName="recruitingAlternatePhone"
                        (keyup)="recruitingAlternatePhoneUniqueNumbers($event)" mask='(000) 000-0000' pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.recruitingAlternatePhone.touched) && registerProfileFormControl.recruitingAlternatePhone.errors?.required">
                      </span>
                      <span class="text-danger" *ngIf="isRecruitingAlternatePhoneUniqueNumbers">
                        Please Enter a Valid Phone Number
                      </span>
                      <span class="text-danger" *ngIf="isRecruitingAlternatePhoneNumberValid">
                        Please Enter a Valid Phone Number
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-1">

                    </div>
                  </div>
                  <span class="text-md text-dark font-weight-bold">Financial / Auditing and Compliance</span>
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-1">

                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="financialName">Name <span
                        *ngIf="!forIndividual" class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="financialName"
                        pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.financialName.touched) && registerProfileFormControl.financialName.errors?.required">
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="financialTitle">Title <span
                        *ngIf="!forIndividual" class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="financialTitle"
                        pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.financialTitle.touched) && registerProfileFormControl.financialTitle.errors?.required">
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="financialEmail">Email<span
                        *ngIf="!forIndividual" class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="financialEmail"
                        pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.financialEmail.touched) && registerProfileFormControl.financialEmail.errors?.required">
                      </span>
                      <span class="text-danger"
                        *ngIf="registerProfileFormControl.financialEmail.touched && registerProfileFormControl.financialEmail.errors?.pattern">
                        Please enter a valid email address
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="financialPhone"> Phone<span
                        *ngIf="!forIndividual" class="required-field">*</span> </label>
                      <input type="text" class="form-control" formControlName="financialPhone" mask='(000) 000-0000'
                        (keyup)="financialPhoneUniqueNumbers($event)" pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.financialPhone.touched) && registerProfileFormControl.financialPhone.errors?.required">
                      </span>
                      <span class="text-danger" *ngIf="isFinancialPhoneUniqueNumbers">
                        Please Enter a Valid Phone Number
                      </span>
                      <span class="text-danger" *ngIf="isFinancialPhoneNumberValid">
                        Please Enter a Valid Phone Number
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="financialAlternatePhone"> Alternate Phone<span
                        *ngIf="!forIndividual" class="required-field">*</span> </label>
                      <input type="text" class="form-control" formControlName="financialAlternatePhone"
                        (keyup)="financialAlternatePhoneUniqueNumbers($event)" mask='(000) 000-0000' pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.financialAlternatePhone.touched) && registerProfileFormControl.financialAlternatePhone.errors?.required">
                      </span>
                      <span class="text-danger" *ngIf="isFinancialAlternatePhoneUniqueNumbers">
                        Please Enter a Valid Phone Number
                      </span>
                      <span class="text-danger" *ngIf="isFinancialAlternatePhoneNumberValid">
                        Please Enter a Valid Phone Number
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-1">

                    </div>
                  </div>
                  <span class="text-md text-dark font-weight-bold">Accounting</span>
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-1">

                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="accountingName">Name <span *ngIf="!forIndividual"
                        class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="accountingName"
                        pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.accountingName.touched) && registerProfileFormControl.accountingName.errors?.required">
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="accountingTitle">Title <span *ngIf="!forIndividual"
                        class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="accountingTitle"
                        pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.accountingTitle.touched) && registerProfileFormControl.accountingTitle.errors?.required">
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="accountingEmail">Email<span *ngIf="!forIndividual"
                        class="required-field">*</span></label>
                      <input type="text" class="form-control" maxlength="100" formControlName="accountingEmail"
                        pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.accountingEmail.touched) && registerProfileFormControl.accountingEmail.errors?.required">
                      </span>
                      <span class="text-danger"
                        *ngIf="registerProfileFormControl.accountingEmail.touched && registerProfileFormControl.accountingEmail.errors?.pattern">
                        Please enter a valid email address
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="accountingPhone">Phone<span *ngIf="!forIndividual"
                        class="required-field">*</span> </label>
                      <input type="text" class="form-control" formControlName="accountingPhone" mask='(000) 000-0000'
                        (keyup)="accountingPhoneUniqueNumbers($event)" pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.accountingPhone.touched) && registerProfileFormControl.accountingPhone.errors?.required">
                      </span>
                      <span class="text-danger" *ngIf="isAccountingPhoneUniqueNumbers">
                        Please Enter a Valid Phone Number
                      </span>
                      <span class="text-danger" *ngIf="isAccountingPhoneNumberValid">
                        Please Enter a Valid Phone Number
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <label for="accountingAlternatePhone">Alternate Phone <span *ngIf="!forIndividual"
                        class="required-field">*</span></label>
                      <input type="text" class="form-control" formControlName="accountingAlternatePhone"
                        (keyup)="accountingAlternatePhoneUniqueNumbers($event)" mask='(000) 000-0000' pInputText>
                      <span class="text-danger"
                        *ngIf="(registerProfileFormControl.accountingAlternatePhone.touched) && registerProfileFormControl.accountingAlternatePhone.errors?.required">
                      </span>
                      <span class="text-danger" *ngIf="isAccountingAlternatePhoneUniqueNumbers">
                        Please Enter a Valid Phone Number
                      </span>
                      <span class="text-danger" *ngIf="isAccountingAlternatePhoneNumberValid">
                        Please Enter a Valid Phone Number
                      </span>
                    </div>
                    <div class="p-field p-col-12 p-md-1">

                    </div>
                  </div><br>
                </div>
              </div>
            </ng-template>
          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab [selected]="false">
            <ng-template pTemplate="header"><span style="font-family: Roboto,'system-ui',sans-serif;font-size: 17px;">Reference</span> <span *ngIf="forIndividual"
                style="font-weight:400;font-style:oblique ; color: #007bff;"> - This section is optional for the
                Individual Entity</span></ng-template>
            <ng-template pTemplate="content">
              <div class="row">
                <div class="col-lg-12">
                  <section>
                    <div formArrayName="referenceFields">
                      <div class="p-fluid p-formgrid p-grid"
                        *ngFor="let control of registerProfileForm.controls.referenceFields['controls']; let i=index;"
                        [formGroupName]="i">
                        <div class="p-field p-col-12 p-md-11">
                          <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-3">
                              <label for="bmContactName">Client Name<span *ngIf="!forIndividual && i==0"
                                  class="required-field">*</span></label>
                              <input type="text" class="form-control" maxlength="100" formControlName="refClientName"
                                pInputText>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refClientName').touched) &&  referenceFields.controls[i].get('refClientName').errors?.required">
                              </span>
                            </div>
                            <div class="p-field p-col-12 p-md-3">
                              <label for="bmPhone">Contact Name<span *ngIf="!forIndividual && i==0"
                                  class="required-field">*</span></label>
                              <input type="text" class="form-control" maxlength="100" formControlName="refContactName"
                                pInputText>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refContactName').touched) &&  referenceFields.controls[i].get('refContactName').errors?.required">
                              </span>
                            </div>
                            <div class="p-field p-col-12 p-md-3">
                              <label for="bmOfficeCity">Contact Title<span *ngIf="!forIndividual && i==0"
                                  class="required-field">*</span></label>
                              <input type="text" class="form-control" maxlength="100" formControlName="refContactTitle"
                                pInputText>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refContactTitle').touched) &&  referenceFields.controls[i].get('refContactTitle').errors?.required">
                              </span>
                            </div>
                            <div class="p-field p-col-12 p-md-3">
                              <label for="bmAddress">Contact Email<span *ngIf="!forIndividual && i==0"
                                  class="required-field">*</span></label>
                              <input type="text" class="form-control" maxlength="100" formControlName="refContactEmail"
                                (keyup)="referenceEmail($event,i)" pInputText>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refContactEmail').touched) &&  referenceFields.controls[i].get('refContactEmail').errors?.required">
                              </span>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refContactEmail').touched) && referenceFields.controls[i].get('refContactEmail').errors?.pattern">
                                Please Enter a Valid Email Address
                              </span>
                            </div>
                          </div>
                          <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-3">
                              <label for="contactPhoneNumber">Contact Phone Number <span *ngIf="!forIndividual && i==0"
                                  class="required-field">*</span></label>
                              <input type="text" class="form-control" formControlName="refContactPhoneNumber"
                                (keyup)="onreferencePhoneUniqueNumbers($event,i)" mask='(000) 000-0000' pInputText>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refContactPhoneNumber').touched) &&  referenceFields.controls[i].get('refContactPhoneNumber').errors?.required">
                              </span>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refContactPhoneNumber').touched) &&  referenceFields.controls[i].get('refContactPhoneNumber').errors?.pattern">
                                Please Enter a Valid Phone Number
                              </span>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refContactPhoneNumber').touched) && referenceFields.controls[i].get('refContactPhoneNumber').errors?.minlength">
                                Please Enter a Valid Phone Number
                              </span>
                            </div>
                            <div class="p-field p-col-12 p-md-3">
                              <label for="industry">Industry <span *ngIf="!forIndividual && i==0"
                                  class="required-field">*</span></label>
                              <input type="text" class="form-control" maxlength="100" formControlName="refIndustry"
                                pInputText>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refIndustry').touched) &&  referenceFields.controls[i].get('refIndustry').errors?.required">
                              </span>
                            </div>
                            
                            <div class="p-field p-col-12 p-md-3">
                              <label for="revenue">Revenue<span *ngIf="!forIndividual && i==0" class="required-field">*</span></label>
                              <input class="form-control" maxlength="12" formControlName="refRevenue" (keypress)="onlyNumberWithDecimal($event)"
                                type="text" pInputText>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refRevenue').touched) && referenceFields.controls[i].get('refRevenue').errors?.required">
                              </span>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refRevenue').touched) && referenceFields.controls[i].get('refRevenue').errors?.pattern">
                                Please enter valid Revenue
                              </span>
                            </div>
                            <div class="p-field p-col-12 p-md-3">
                              <label for="duration">Duration of Partnership(Years)<span
                                  *ngIf="!forIndividual && i==0" class="required-field">*</span></label>
                              <input type="text" class="form-control" maxlength="3"
                                formControlName="refDurationOfPartnership" (keypress)="onlyNumbers($event)" pInputText
                                preventCutCopyPaste>
                                <span class="text-danger"
                              *ngIf="(referenceFields.controls[i].get('refDurationOfPartnership').touched) &&  referenceFields.controls[i].get('refDurationOfPartnership').errors?.required">
                            </span>
                            </div>
                          </div>

                          <div class="p-fluid p-formgrid p-grid">
                            
                            <div class="p-field p-col-12 p-md-12">
                              <label for="services">Services Provided<span *ngIf="!forIndividual && i==0"
                                  class="required-field">*</span></label>
                              <input type="text" class="form-control" maxlength="500"
                                formControlName="refServicesProvided" pInputText>
                              <span class="text-danger"
                                *ngIf="(referenceFields.controls[i].get('refServicesProvided').touched) &&  referenceFields.controls[i].get('refServicesProvided').errors?.required">
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="p-field p-col-12 p-md-1">
                          <div class="p-d-flex p-jc-between">
                            <button *ngIf="i>0" (click)="removeReferenceFields(i)" pButton pRipple type="button"
                              icon="pi pi-minus" class="p-button-rounded p-button-danger ext-right"></button>
                            <div *ngIf="refArraySize">
                              <button (click)="addReference()" pButton pRipple type="button" icon="pi pi-plus"
                                class="p-button-rounded float-right"></button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </section>

                </div>
              </div>
            </ng-template>
          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab header="Admin Details" [selected]="false">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="firstName">First Name <span class="required-field">*</span></label>
                    <input type="text" maxlength="100" class="form-control"
                      (keyup)="preventSqlCommentsOnFirstName($event)" formControlName="firstName" pInputText>
                    <span class="text-danger" *ngIf="isSqlCommentsOnFirstName">
                      Please enter a valid First Name
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="middleName">Middle Name</label>
                    <input type="text" maxlength="50" class="form-control"
                      (keyup)="preventSqlCommentsOnMiddleName($event)" formControlName="middleName" pInputText>
                    <span class="text-danger" *ngIf="isSqlCommentsOnMiddleName">
                      Please enter a valid Middle Name
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="lastName">Last Name <span class="required-field">*</span></label>
                    <input type="text" class="form-control" maxlength="100"
                      (keyup)="preventSqlCommentsOnLastName($event)" formControlName="lastName" pInputText>
                    <span class="text-danger" *ngIf="isSqlCommentsOnLastName">
                      Please enter a valid Last Name
                    </span>
                  </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="userEmailId">Email Address<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="adminEmailId"
                      (keyup)="onAdminEmailAvailabilityCheck()" type="email" pInputText>
                    <span class="text-danger"
                      *ngIf="(registerProfileFormControl.adminEmailId.touched) && registerProfileFormControl.adminEmailId.errors?.required">
                    </span>
                    <span class="text-danger"
                      *ngIf="registerProfileFormControl.adminEmailId.touched && registerProfileFormControl.adminEmailId.errors?.email">
                      Please Enter a Valid Email Address
                    </span>
                    <span class="text-danger"
                      *ngIf="registerProfileFormControl.adminEmailId.touched && registerProfileFormControl.adminEmailId.errors?.pattern">
                      Please Enter a Valid Email Address
                    </span>
                    <span class="text-danger"
                      *ngIf="registerProfileForm?.controls?.adminEmailId?.hasError('emailInvalid')">
                      Please Enter a Valid Email Address<br />
                    </span>
                    <span class="text-danger"
                      *ngIf="registerProfileForm?.controls?.adminEmailId?.hasError('emailEntityInvalid')">
                      Please Enter your Business Email Address<br />
                    </span>
                    <span class="text-danger" *ngIf="adminEmailAvail">
                      The Email is already in use
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="PhoneNumber">Phone Number <span class="required-field">*</span></label>
                    <input type="text" class="form-control" formControlName="phoneNumber" mask='(000) 000-0000'
                      (keyup)="userPhoneUniqueNumbers($event)" pInputText>
                    <span class="text-danger" *ngIf="isUserPhoneUniqueNumbers">
                      Please Enter Valid Phone Number
                    </span>
                    <span class="text-danger" *ngIf="isUserPhoneNumberValid">
                      Please Enter Valid Phone Number
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf=phoneExtDisabled>
                    <label for="extNumber">Extension Number</label>
                    <input type="text" class="form-control" maxlength="6" formControlName="extNumber"
                      (keypress)="onlyNumbers($event)" pInputText disabled>
                    <span class="text-danger"
                      *ngIf="registerProfileFormControl.extNumber.touched && registerProfileFormControl.extNumber.errors?.pattern">
                      Please Enter Valid Ext Number
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf=!phoneExtDisabled>
                    <label for="extNumber">Extension Number</label>
                    <input type="text" class="form-control" maxlength="6" formControlName="extNumber"
                      (keypress)="onlyNumbers($event)" pInputText>
                    <span class="text-danger"
                      *ngIf="registerProfileFormControl.extNumber.touched && registerProfileFormControl.extNumber.errors?.pattern">
                      Please Enter Valid Ext Number
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab header="Master Service Agreement (MSA)" [selected]="false">
            <div class="container-fluid" id="makepdf">

              <div class="card pdftop">
                <div class="row">
                  <div class="col-md-6" style="margin-left:35px;"><br>
                    <img class="logo"
                      src="data:image/png;base64,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"
                      width="200px">
                  </div>
                </div>
                <div class="container">

                  <h5 style="text-align:center;margin-top:20px;"><b>MASTER CONTRACTOR AGREEMENT</b></h5><br>
                  <ul class="pdftext">
                    <li *ngIf="address2OnMSADoc != undefined && address2OnMSADoc != ''">An agreement made this <span style="font-weight: bold;">{{dateOnDoc}}</span> between DevCare Solutions, Ltd. (DevCare Solutions) located at 579 Executive Campus
                      Dr, Ste 370, Westerville, OH - 43082 and <span style="font-weight: bold;">{{vendorNameOnMSADoc}}</span> (Contractor), with address:<span style="font-weight: bold;">{{addressOnMSADoc}},&nbsp;{{address2OnMSADoc}},&nbsp;{{cityOnMSADoc}},&nbsp;{{stateOnMSADoc}},&nbsp;{{zipCodeOnMSADoc}}</span>
                      and Federal Tax ID:<span style="font-weight: bold;">{{taxIdOnMSADoc | mask:'00-0000000'}}</span></li><br>
                      <li *ngIf="address2OnMSADoc == undefined || address2OnMSADoc == ''">An agreement made this <span style="font-weight: bold;">{{dateOnDoc}}</span> between DevCare Solutions, Ltd. (DevCare Solutions) located at 579 Executive Campus
                        Dr, Ste 370, Westerville, OH - 43082 and <span style="font-weight: bold;">{{vendorNameOnMSADoc}}</span> (Contractor), with address:<span style="font-weight: bold;">{{addressOnMSADoc}},&nbsp;{{cityOnMSADoc}},&nbsp;{{stateOnMSADoc}},&nbsp;{{zipCodeOnMSADoc}}</span>
                        and Federal Tax ID:<span style="font-weight: bold;">{{taxIdOnMSADoc | mask:'00-0000000'}}</span></li><br>
                      <li>1.&nbsp;&nbsp;SCOPE The terms of this Agreement apply in a situation where Contractor agrees to provide
                      programming, systems
                      analysis, engineering, technical writing or other specialized services directly to the third-party
                      user("client") who has
                      requested DevCare Solutions to locate temporary staffing for the client’s project according to the
                      training, skills, abilities and
                      experience required by the client. DevCare Solutions agrees to refer Contractor to the client for
                      further evaluation and
                      possible retention of Contractor’s services. Contractor will undertake the services provided as an
                      independent contractor,
                      determining the manner and method of its performance of the services
                    </li><br>
                    <li>2.&nbsp;&nbsp;TERM OF AGREEMENT Nothing in this agreement obligates Contractor to accept any offer to provide
                      services.
                      However, all terms and conditions shall remain in force during any and all periods for which
                      Contractor’s services are
                      provided to the client and for any other periods before and/or thereafter as stated herein. In
                      addition, paragraphs 4, 5 and 8
                      shall apply even if Contractor rejects an assignment offered by the Client and does not provide
                      its services, in which case,
                      however, DevCare Solutions shall have no further obligation to Contractor. Prior to the
                      commencement of such services,
                      DevCare Solutions and Contractor will execute a Purchase Order on the form attached to this
                      Agreement which shall be
                      considered part of this Agreement and binding upon both parties as such. Contractor’s services
                      under this Agreement will
                      terminate at the end of the minimum time requirement period covered by the Purchase Order and any
                      renewals or
                      extensions thereof ("end date"), or upon twenty-four hours’ notice if for any reason the Client no
                      longer desires the services
                      of Contractor. Contractor may terminate its services under this Agreement before the end date upon
                      fifteen (15) days written
                      notice to DevCare Solutions.
                    </li><br>
                    
                    <li>3.&nbsp;&nbsp;ASSIGNMENT OF CONTRACT Any work on a project will be in accordance with the terms of this
                      Agreement and the
                      Purchase Order. Contractor is to provide services through its personnel named in paragraph 8 of
                      the Purchase Order, for
                      whom it is responsible, and may not assign its rights under this Agreement or any Purchase Order
                      and may not subcontract
                      its obligations hereunder to others without the written consent of DevCare Solutions. In case of
                      assignment or subcontract,
                      Contractor shall be liable to DevCare Solutions for damages due to any lost or reduced fees
                      received by DevCare Solutions
                      as a result thereof. Contractor shall provide proof to DevCare Solutions that the person or
                      company performing services for
                      Contractor is legally authorized to work in the United States, including, but not limited to proof
                      of incorporation, valid visas or
                      work authorizations, and/or proof of corporate insurance. DevCare Solutions may arrange for other
                      independent contractors
                      to perform the same work that Contractor performs on any assignment in accordance with DevCare
                      Solutions’ agreements
                      with the Client.
                    </li><br>
                    <li>4.&nbsp;&nbsp;NON-SOLICITATION, NON-COMPETITION Contractor acknowledges that Client has a relationship with
                      DevCare
                      Solutions, that but for DevCare Solutions Contractor would have no relationship with Client, and
                      that Contractor benefits
                      from this relationship. Therefore, Contractor covenants that it shall not, through its employees
                      or third parties, directly or
                      indirectly through third parties, compete or attempt to compete with DevCare Solutions directly
                      with Client nor solicit or
                      attempt to solicit any business from Client. Further, Contractor hereby covenants that it shall
                      not, directly or indirectly,
                      conduct any business outside of this Master Contract Agreement and its renewals with Client, even
                      if requested by Client,
                      unless authorized in writing by DevCare Solutions. This covenant shall be in force from the date
                      of the signing of this
                      agreement until the expiration of one year after any person related in any way to Contractor does
                      any work in any capacity
                      for Client, regardless of whether DevCare Solutions is involved, whether it be by this contract,
                      renewal or outside of this
                      contract or renewal. Contractor acknowledges and agrees to pay DevCare Solutions reasonable
                      attorneys’ fees if DevCare
                      Solutions incurs any attorneys’ fees or costs related to enforcement of this section including,
                      but not limited to, any fees and
                      costs incurred prior to the initiation of formal legal proceedings. Contractor acknowledges that
                      its execution of this contract
                      does not violate any prior non-compete agreements with any other parties that would prevent
                      Contractor Personnel from
                      seeking employment with DevCare Solutions or Contractor from providing services to DevCare
                      Solutions and/or Client.
                      Contractor agrees to defend, indemnify and hold harmless DevCare Solutions and/or Client and
                      its/their directors, officers,
                      employees, and agents, from and against any and all claims, damages, costs, expenses, or
                      liability, based upon, arising out
                      of, or in any way related to any violations of other non-compete agreements. This obligation will
                      survive any termination of
                      this agreement. DevCare Solutions shall not solicit/hire Contractor’s Personnel during the term of
                      this agreement and one
                      year thereafter.
                    </li><br>
                    <li>5.&nbsp;&nbsp;REPRESENTATION Contractor acknowledges for itself and its personnel that information provided by
                      it (including, but
                      not limited to resumes, interviews, references) in consideration for providing services to or on
                      behalf of the Client is true to
                      the best of Contractor’s knowledge, that it is not restricted by any employment or other
                      Contractor agreement, and
                      Contractor understands that any misstatements or lack of candor by Contractor of the
                      qualifications or availability of it or its
                      personnel may be grounds for immediate termination by the Client of any assignment, and
                      constitutes breach of this
                      Agreement.
                    </li><br><br><br>
                    <div class="row" style="font-size: 11px;">
                      <div class="col-md-6">
                       DevCare Solutions, Ltd. 
                      </div>
                      <div class="col-md-6" style="text-align:right;">
                        Page 1 of 3
                       </div>
                     </div>
                   </ul>
                   
                </div>
              </div>
              <br />

              <div class="card pdftop">
                <div class="row">
                  <div class="col-md-6" style="margin-left:35px;"><br>
                    <img class="logo"
                      src="data:image/png;base64,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"
                      width="200px">
                  </div>
                </div>
                <div class="container">

                  <h5 style="text-align:center;margin-top:20px;"><b>MASTER CONTRACTOR AGREEMENT</b></h5><br>
                  <ul class="pdftext">
                    <li>6.&nbsp;&nbsp;PAYMENT FOR SERVICES Contractor shall maintain timesheets indicating the hours that services have
                      been
                      performed, shall have a Client representative verify those hours by signing the timesheets and
                      submit these to DevCare
                      Solutions along with Contractor’s invoice for the amount due to Contractor for the verified
                      billable hours. Payment for hours
                      actually worked will be made in Contractor’s corporate name at the agreed upon hourly rate set
                      forth in the related Purchase
                      Order. Payment to Contractor per the invoice shall be made as per the option selected below (this
                      will be effective for the
                      term of this agreement):<br>
                      
                      <span [hidden]="net45WithoutFee" style="font-weight:bold;"><br>{{net30WithFeeOnMSADoc}} within thirty (30) days of DevCare Solutions' receipt of invoice and client approved timesheets
                      from the
                      Contractor. This payment option is subject to a charge of two percent (2%) of the invoice amount
                      to be retained by DevCare
                      Solutions.<br></span>
                      <span [hidden]="net30WithFee" style="font-weight:bold;">
                        <br>{{net45WithoutFeeOnMSADoc}} within forty-five (45) days of DevCare Solutions' receipt of invoice and client approved
                      timesheets from the
                      Contractor.<br></span>
                      
                      <br>DevCare Solutions or Client will provide no other compensation in any form, including benefits.
                      Contractor acknowledges
                      and agrees that under no circumstances will DevCare Solutions have any obligation to invoice
                      Client or pay Contractor for
                      billable time reported to DevCare Solutions after sixty (60) days following the end of a weekly
                      time reporting cycle.
                      Notwithstanding anything to the contrary contained herein, Contractor agrees not to invoice
                      DevCare Solutions and
                      DevCare Solutions shall not pay Contractor for the billable time of any Contractor Personnel who
                      leaves his/her assignment
                      at Client or who is removed from such assignment (whether by Contractor or at the request of
                      DevCare Solutions or Client)
                      within the first ten (10) business days of such assignment, regardless of the reason. A background
                      check/drug testing fee
                      will be deducted from the first invoice if required by the Client.

                    </li><br>
                   
                    <li>7.&nbsp;&nbsp;TRAVEL, LIVING AND OTHER COSTS No travel, living, training, entertainment or other costs will be
                      allowed for
                      Contractor unless authorized in advance and paid by the Client for whom Contractor is performing
                      services. DevCare
                      Solutions will provide no training, tools, equipment or other materials to Contractor.
                    </li><br>
                   
                    <li>8.&nbsp;&nbsp;CONFIDENTIALITY Contractor agrees that neither it nor its personnel will disclose to any third
                      party, without the prior
                      written consent of an executive officer of DevCare Solutions, any information relating to the
                      business of DevCare Solutions,
                      the Client, the customers and clients of the Client, or other DevCare Solutions‘ Contractors, if
                      such information could
                      reasonably be construed as confidential and was obtained in the course of Contractor’s assignment
                      with a Client project,
                      interviewing with DevCare Solutions or contracting with DevCare Solutions. Contractor further
                      agrees neither it nor its
                      personnel will reproduce in any way, divulge, or remove from the premises of DevCare Solutions any
                      Client or the
                      customers and clients of any Client, at any time during the interview, assignment or upon leaving
                      the assignment, any
                      tangible or intangible property whatsoever (except personal effects) which could reasonably be
                      construed as constituting
                      confidential information of DevCare Solutions, the Client, or the customers or clients of the
                      Client
                    </li>
                    <br>
                    <li>9.&nbsp;&nbsp;CONDUCT, INDEPENDENT STATUS AND BENEFITS Contractor shall provide competent, professional services
                      in the
                      required disciplines, using its own appropriate independent skill and judgment and determining the
                      manner and means that
                      appear most suitable to perform the work. Evaluation of Contractor’s performance, if any, shall be
                      made by the Client. The
                      parties to this Agreement agree that the relationship created by this Agreement is that of
                      broker-independent contractor.
                      Contractor agrees and has advised its personnel, who have agreed in writing to be provided to
                      DevCare Solutions within 5
                      days of the date of this Agreement, that neither Contractor nor any of its personnel is an
                      employee of DevCare Solutions or
                      the Client or is entitled to any benefits provided or rights guaranteed by DevCare Solutions or
                      the Client; or by operation of
                      law, to their respective employees, including, but not limited to group insurance, liability
                      insurance, disability insurance, paid
                      vacations, sick leave or other leave, retirement plans, health plans, premium "overtime" pay, and
                      the like. It is understood
                      and agreed that since the Contractor is an independent contractor, DevCare Solutions will make no
                      deductions from fees
                      paid to Contractor for any federal or state taxes or FICA, and DevCare Solutions and the Client
                      have no obligation to
                      provide Worker’s Compensation coverage for Contractor or to make any premium "overtime" payments
                      at any rate other
                      than the normal rate agreed to in the Purchase Order. It shall be the Contractor’s responsibility
                      to provide Worker’s
                      Compensation and if applicable, pay any premium "overtime" rate, for its employees who work on the
                      project covered
                      services provided by the Contractor or its personnel. DevCare Solutions will not indemnify
                      Contractor for any liability
                      incurred by Contractor, its agents or employees. It is understood and agreed that DevCare
                      Solutions and the Client have no
                      obligation to provide unemployment compensation
                    </li><br>
                   
                    <li>10.&nbsp;LIABILITY Because of the independent status of the Contractor, it is solely and completely
                      accountable for the services it
                      provides to the Client, and neither the Client nor its customers and clients, nor DevCare
                      Solutions shall have any liability
                      whatsoever to any party for such services provided by Contractor or its personnel. DevCare
                      Solutions will not indemnify
                      Contractor for any liability incurred by Contractor, its agents or employees. Contractor
                      understands that DevCare Solutions
                      will act in good faith to describe the task requirements set forth by the Client, but that because
                      Contractor has the
                      opportunity to discuss directly with the Client these task requirements prior to acceptance of the
                      project assignment offered
                      by the Client, and because DevCare Solutions has no right to control any aspect of the project on
                      which the Contractor will
                      be working, Contractor hereby releases DevCare Solutions from any liability relating to
                      representations about the task
                      requirements or to the conditions under which the Contractor will be working. Contractor also
                      agrees to release DevCare
                      Solutions from any liability for statements made by DevCare Solutions, without malice, to third
                      parties who inquire about
                      Contractor’s performance
                    </li>
                    <br><br><br>
                    <div class="row" style="font-size: 11px;">
                      <div class="col-md-6">
                       DevCare Solutions, Ltd. 
                      </div>
                      <div class="col-md-6" style="text-align:right;">
                        Page 2 of 3
                       </div>
                     </div>
                  </ul>
                </div>
              </div>
              <br />
              <div class="card pdftop">
                <div class="row">
                  <div class="col-md-6" style="margin-left:35px;"><br>
                    <img class="logo"
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMMAAAA8CAYAAADbuw5mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkY2NzY4QjExRDU4NDExRUI5NDg5RDU3QUFCQUUyM0M0IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkY2NzY4QjEyRDU4NDExRUI5NDg5RDU3QUFCQUUyM0M0Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RjY3NjhCMEZENTg0MTFFQjk0ODlENTdBQUJBRTIzQzQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RjY3NjhCMTBENTg0MTFFQjk0ODlENTdBQUJBRTIzQzQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7oJnMyAAAVXklEQVR42uxdCZhU1ZU+VdVFd4MNNpugIKCiggqyiYDJRFBQwCVGxwWDIkpixIQMMRNHYzAmmaAiKAQNiOOKcdRM1EkMo2IL7iAMgqytTSsBugWapYFe6+WcV/+jb9+6t7qququr5Xvn+w5U3XrLffee5T/nnnc74DgO+eSTT0RBfwh88slXBp988pXBJ598ZfDJJ18ZfPLJVwaffPKVwSefkqXAyT16+qOQRtrtODQ4GKK5WblUTQ7VtKC+dQ4E6K1IDU2vqaA8CjSFZRzBfBHzLxtxjWOY2zJvb65xKNxa5HsGn9gaNu3lTmO+Nonjc5h7MYeUthuY32XO8mGST81KWU2rEAeZdyRxfHvm55lrlbaFzFdrbc02FoKTpCajgrkan5MxLNLpSpzvU3qoL/N5zGcy92buwpzLHGH+mnkj8yfMBcybLdf4C/MzzC97EyeQrSBSS5U8421jNeIHzMcxv8a8WvvtRuYeuOf/xun3GehfqSJvfZjXMeczT2E+mflm5n3wELuZ39PkUJ71JuYOzG8zL1d+O5F5P3M58zTI4lwD9JqC+7/E/IVNGVYwVzF3Yg6j45E4wp+FTofgWaphEfbiwcUyfMW8iflT5rXooE/JY+fvA3Z8K85xIlzfVr4vZV7A/ILS9i/MlzG/pZ4ok7ydYxrNBOcxPwl52Ml8DvNk5hIo4d+YDzFvRd/kt+9a+vZfzE8wP4bvxzIvZr4CcnMhczbzOAi0dGUoZPB8nNOP+RWB9mi/GYr9Y/w+Hoq7EY8kUO0q5jHMh5m7MT+L64cxXlNw/xhlGI+L9INmnZnCxMlDnmD5rQgT9Lw+GT5ZSSb3F/DaHm2DFX4XhqYM85YH3D0YwjkSfCfzHAjEHFyjSrdsubEwSQT1XGU+8xWv/wws94WK4oiA3sX8WwOqCBi+B+Bx5DkmQmmvgqMSupT5buX4F5n/znwr2nrD+y2Dlfdk9y7FS0mfbmF+hPlnMNqX4rdONvQjyvARPouHWIROjtCOk5M/ZP4ALu5L5l3QrjCwXy9o9fnosEe9YD0mw43/xlcKK50Mqz5SaZOJnQEra4Oin8J6Shbncghmf5yjUgd9Ug+wZ9Ak4/+Z2zD/hPlhKB1BMftoXuoA86+Zr8Q99WRZpYb9HbTVKMoUwv9lSlDtPedQfL9VucYWPNf3oQzyTK9qcO11KAhBaW5EH18Cekk4gF5kaCvDBE1HR0SY1zCvx/9vwx2KRTsVLnmp4TrfYX6T+SFf7mPofBgkVRHegFA/mkRMJhDiLOY/WDz4EakUSzgylEXZgXqmcg0E5wZ89rJDJyhQmDSPFVKQl+4JIpoyqLoXwjEhi0yeYhHeYjg1grI5BuPtwaA/Q7FFaT+GDCasDF8a2iJahxsi0dRRwGZVht9/Ck0+6rNZMnCtAIwj9sNGw3jka2M4Grg9ldtOZZ5pU4YITK4bSMeCBjFYA2G0FsEbrIcFP0Y7trMSE+oyEtLmfzeEN6j87pjwu3J8O0N7F8SpZLlvUBvup5CE+CuMxRmJKsN+S+Ccm8KkLEQAttXw2zh07qimsGtOHdrD3Mp8SD8EpSptBNxpLP0CShWjDO0CAfrUidCjtVU8sQEV3HfVhGgN4soyCO2d2j3+DRknD3arMlWjwSqx0IMUSHQY8UO1JtjeNZZD8Kdoz3A9YlD9eFWuA4rieHQvlHOwLWYwWZWmpDVwTe8islfpIgR3045WZchnoVsbidBHkVq6giHJjvpvFraGIOmW7TpKLsUdjyYhE5MPy34kVVXE/frCqaVTAiH1ZmKk/h3CdhKc2uNOVLqmwLIKTv+c+XuIMf5TwfuqJb8POH0fnnUgYE8O7rcpEEUiSxC73oVMlXeNcni4eRBgiVOvYX6O+b+VtGueIRPnxSo/RPD8CrJuEl/9T6KeIZAGmShGHGGaYLEWFxytygAh4tkJmAZWAtQTtTbJ2Kxuwi7sQdKCVEGVMpFhoRBdHgzTTv6sCMJiwKP2bNa3sWUcy15ty072ImXkLOXnOZvN+A5u7xCIxiXjFMErgKfwaAmgniiJlFeMZq2/7CA520v4nl87ThWb6cv43u/xtQ7wNav42u/xPaYf4pHbxvfkQOmpYDSeKoeQ3wkB9+hPfO49tW6aOOJ6Yab7+d95u/geB8iZz59fcKJZpGXwcib0Y6xNGoxATsdup0MzG0N3SEcN7YXID0eORoXgSaefhbJpclaYSuo8g1jJTwyHnwF83pSUA2Ha5cEGEZ4T2Gt9wQI0vvoQ7eV+5SgKHGLVFa9Wye3nBLNoVDBESyI1tJI93DHcXs5HSSYqhGt14La2fE4t1S3oeYGm1yb32Mfn9QwE6aZQK9rH3xdGqijCNzyWzz/Mv7XmIw9yezc+Zgjfs4DvKWMmdVRBxbhU4/oBjG8ef7iYFXsrP88a7qPcdyifv4d/28JtlS4+cozW/3BxsRUmpZMeQP63t9Z+Ctz5oqPVOyxzqulaJ6xGdjMNh76VBkUgZKIWIx0psKdShEUg2/Hco+ksmKsZMkkcQRCadixmo1gJ3FUsFswezPJ9AwtWR/5tFcOrFSx0eXyO5GFFaLe6QhxwI9sKvoYI1z5+eDlGlGMEC2dHvs54vs5YZhHovpEgPVhT6S7+zcjKpn4M2Ur43C58Tn8+dj2P2QM1VfRqpNr1rl2hiDXwtnKfMXyta0NhuoD/L+L+bXRqXWWWa+2Hh3mf+yreLSdgBz7N7RmEbrII/VolN3xUUY1rHR2alZVL57JAMEQ5C9hVJ8mnP5amboyEsokH3qwGiB1ZQHJdq+7E5CZFefezoB4ERmkbiFr/ECyp42KvAH3MAjip+rBrmcXD/Dorh3qzMK/l9j4slDl8zEn8XbyRwJcyWOnu3PYln7OD+exg6Ijlr3DI9SIi/NKPv7Ky/am2mpbz/535zIfCOXxuwO3bGXz93EB0NT0XfXTgicJ8tTaB6HMELTi96+Z1GfEMLsZjnqVmNkAiIMMourCXKLUCJr0QwV4YVnAncsqCWf9hMwQUXRMJ2TAkSCxpe2RACi3HSHpRrMoBsHqPfO7Uvr0cN8nkhqPtky3XWZbGcZcExgKMUb2gcY/jmMSkLxIfYhy780lhhhoHGZKUYhzkeu+QO8AikEF6KpxLv2IrP5SF8xb2Nhwb0FAeXi+3Ws73KYzGJwNC0WC8W7ETmcwWvvRMPufr6ALgKB60Cfzb8XxcIQv4Q6xcX1zLEGgcW/4n2Ev0CEa9i/RbDL1Y/z2O+ywX8OSPqXCcUwENK6rJKT3kuDHY/9nmr2ucbFK66RCE9GpLujVRZZBA7R5LHlroB8hF/5H5P8hcHzUHGS0PSkQM2TZROBGAJ5FlsVnd+6EU2XhGLx3t8Id7a1x2pDGEZIJOnyOlmi6qwpg0RFKO81uqK1+IRxLz3McP9EqxE40FnmaFEKv+FVv66vrZGHnu7wWjcPgipbEdxwqlh6Nf5wfqrzaP4d+v5+sM49hmgwzsVIZSAo0kDlBScJOD0VX6bnH6GlHmcFei2aTmoAJL+7AEzj0JabhZSKlJWk8W+M4FJlZLPdpAaVZR/TofDwncSNEisxWwJK01boWg/2zmX8Xpk6TqBsBD/QPniiLIyvxwduX3d2ex6MPTx5/PNvRF6LMWkEC4DALuKcI7yL6cCiWZgFS5R4OQar1FBFPgj0ATEVZFEYZQdL1JxuUFVRGwzrAbn5+j+opASgbsAa8iVPD/LgTu8NhSevE4FGEuri9lHP9K9ddYgoDoqzCfCa0zNAettbSfCkE6ZPld8K4sxEiaTIq3JlL95XpREqlQ/CnVL/noi/P6I9XoUQkmU1gWAMdq95N6rAcTeJ5K8HLkv+X+Ukw3UiZNsiGSPRFMXOhEzrEs5W/NsCIMwzh4JON7sUFhX8ZzDlHaBX4tZeH/vKZ+fl5KObyaKpMHr8V8SFLlOnjyNobjehnajoOyngZIfLU2htImRX43wCN41B0QT2B5UUvwDNvIXKYhD2irfm2LCeqEybiY7EVXsw3Zmm4UW7im0iQDlGqVwrN5lu8OGdxSVoQRoRBNYGX4mlzX3sdy3o4MKkKWYWx+GUfxbzO0TzS0iccdjvhQnlsv9ZFS/yuhTE9DsK9RvIVHzxqu/RqO30DRdz1sxkRW0X+stYnCvdRSYNJuzUJ7JMFdR8s5cwAvqqHtDdE9sPwqifu3vRtQSnWrmh71p+RK2s/FpMsC02sHkA2ZnZVD+YFomjGOsu/OoDJ8C4Klx3Y2WmEQvtMNxxUClhDioee134+F9S7AnHpQSmDMfFj3e6luhdujGYpnuoXstU0ezYVXU2kgoFTGlUGwYrnlt2MsQd0kxSIUJRgwvm1onxznnHna9xDiikTJw7zzPRMqi0X5PMy763BuB8u55RlUhtMMbe0bOGeD9j0/gfvsNCRyRBYuMSCH24D9Z2i/dUFChJBseS/BZ1zSkCxkShkEK9o2ijD1SXXLTydxn08sVjBsOV4s0Uqt7QYLjjUJzzX47K6jyOrt8GAWtUZuHpRjOT+TG2cUWzxlPNI9eyKFnCYLPjVJQ3CzMn+LkzhvhSVOap/pADoU594VBuh0qebeIgng+UpL1kCyUT3IvmYwFzjTo44Izp5o4H7XoU+SWdoZdHGG427B0oY5Qukp+moiegMe17PQUnO0uYFzSlNIxtQY5vrVJPv6Xc2jXZKgLAw3tOcB3r2fSWXItcAhob3ad0lZHq/FAo2l4+Iog2DWWVrs8qMElGEq/n/Ym2Wpr+nFvI9VIVAfIpqoVQaVoQYGZywEp6E3EfsZhCuRKttaw/fsJPp5IuI4dcynNvLZj8+0Z+hoCZTLKHbzKP1FjN9RtJShob579WK1Bgi2qQErIoL/c6VtEMVfHR8BKyW7LrxD8Ap9WBEGBty1hUQC5XzKPP0tzm95sMq3IlGQCpneiU7mpbEztePnY7zDCdxXh+be5hYfZloZTrTcW7Crni7toX2Xco61ae7fo5oyeFbIpgxeTPOIqnWiVVKSkFMfLH/VkIVqYSRQUxarfqgI3StIBJzXzH3RV5jlbcnXm+rimQqg+1vaVxnaOjTgKdJBWyl2PyDJh3c2HNsJMYVYnWfUgT2I6krNHH5muedJLUwJJNEgC2xS13M7YNAcjP/lqkVtRtIzXKc35cUzpQznW9rfNLTp2ZeezdTHuQZMf5PhuAkYx+fVDIsUpY0IZLmpVW118cM4BqIlxNjdodRSNHgFMj2y3YqkNGVlfb0CdTMRa8ZDDd84ZZCV5FGG9n0Wl6dnIAY2Uz+lylHPpZsK3W7H//P0wEPeAziWAvoDrLN4B7FyfTKsCFfDE1yP76LgpyChUJZCwJyOQF+lwd90ZZgAhdDpWUMmyZRdEq/Supn6utDglcYr378NeCMC/rE+sOX1C9ZUetFyv4syqAg/QjzWQVFuSReXtCDopsvCEIp9bfYbpQymMmixMraCuG3ady/vnwoJ1PGW+xOhpyl2Qeh25bNX8/Kw6YFCdtxjS9NOTPPYSxpzkAW2qvssfao9Z0uh7Yb5vLER1xM4ODpTynCvBefdR/ZCKxOkSHWtQaoopR7lUILH74a1VEkGz3sxSXaHqDIcc2T3LAuWkIzSHy1xw/g0jv/LapCvyICuzA9Ty6R1hjbZUKJdCtc6D3CwKhPKMMIixOugJDb62IBXBa4sSKEP8g62vESzOYlz5luU6gp8XmTwHu57v0sjte7rjJZVJamvMe2S92Caxl9g0DiKreAUBTxLa9vQQpVhE8WuEbU3KHgiJMZIFkAL4ilDOl4wkSDMtOx+iOo2PraRHGPa9lyqFe9Oog8iZJIGnZlk3yWg1IvB7laUxLSNowuR5D3fSrvFkcyTqWjwNIotGGwseTBILP6bhrnRKZGY7IDhkZMlJ4VA/M+GtkuSHDPJisk7LrMbihnCTTwRsqPe+xSbIxY5kf2SihO4xmxL+33A3w1VWMo+m9PhYZ5M4Rl0gZcFMinpWGaBce5yZ1uXA/Eq8KTQ7HFDuyzi/byJxl+CzKVQ6mkWgdRpTAKx5iADflcpH2MU716p/K2U+ZY+y5j9JYGAWsbgIWSmZjWkDO0s3iKVP0YiQdgHsMgqiQIMp8Tfd15N9mrVSYBaohjfoWievCuCZBkgqVz1XlSRUoLqFJ7jRTL/jbE/2E6Q/X9kT6LPnFp3/6E45k88nKkMYiZgXWNoHGDmdordWd0jU6w2lcxl3Z6XKTVcT11Bl9ql9YZ5NwX0eUk+kyRUfmP5TV5bXQthH434VGRByjik2vVdxbDeRVrlrUkZzrJ4i0TdWQ6yPbK49IjhHs/CWq1KchCkHMBWXNcV0EXeX9gIXg3XOVAJHl9IUahqKHZ7m50Wl31kEGSnumWRGne7kmDDQmu6lix2rUwhqG4HRRJ4WYS4wFYgKO8063/JRha3liNB0AbfJeB8Dl5muwFudYYCe7t37zR4TVNxZirbA90Tx5C2BQxaosiCKMhCRYEFqcRsZqfvmyTvmr4D66rTJxDwQlj2UgxwCC5R/rbAAEAf0zurr0Mr32iEpesJge+Z5Hkr4YmqG3HvbrCiHjb+PcVuwqsFBY67EdaCrFzXrSbwwoJsOjDD8ptM4EsQRhHw/QZhFAs4FkGyGDB5r/saavh9gckWuOZ58YgypwLtJgB22oL9LcDkNYZkyBCtbS0UbX8KCr+Ukl+E/RzQ/YhXGLDlsyPKcAfV/fWTpsxzV8BVLoHVW9lE1xV3/BQlvj+rvDd9FTXNm2QvK1mkk8nyt8E8ktqkTuwV5rEydGWlKE/MuQ6Fl4vnDSQ1W0LRF+iDMEa9qa4cWoLbO8icvrXRAkC2ePN5G9WtkVxgMWzefqYHAJMuQZAusmV75VXSm48hi/V3SnxzBPE08u72lQke/xGOrbd2pSrDFgxqNh5gbxxIFKC6zcnUrcArEJyWYKK2QOML05hmk1ThFLIX/W2CMMxuwnt6u9J9QOaXRWIG60uGSr/PyqaJoVbuznFJkPwdNlkTuZBit+OkON5jMVKN+1N4vp8AjqoFcO773IBARYbExDTg/iJAyd8p8jMAwpqDhEkJmf/UVUeqqzuaRuZXNOPR9YhzhsaJixYCGsU4aFUZ6BtOwxEsd4Fy7gJWLWgkLIqHV9+E4DVIsseP7FE6MyvHfcchhb/nmg2F74tMSUe0iVBJ2nkH1b14X9wEzxeGELeHcVxPses8KvWAB9hA9f+ASCZoEGDTCXiOMvSrIF7fjiiD4zjkk08++X8U3SeffGXwySdfGXzyyVcGn3zylcEnn3xl8MknXxl88slXBp988pXBJ58aTf8UYAD5AOoGY8J3MgAAAABJRU5ErkJggg=="
                      width="200px">
                  </div>
                </div>
                <div class="container">
                <h5 style="text-align:center;margin-top:20px;"><b>MASTER CONTRACTOR AGREEMENT</b></h5><br>
                  <ul class="pdftext">
                    <li>11.&nbsp;INSURANCE Contractor will obtain and maintain during the term of this Agreement, for itself and
                      its personnel before
                      providing services, at its own expense, the types and levels of insurance as set forth in Exhibit
                      A. Contractor will provide
                      proof of such insurance in the form of a certificate of insurance with the following language:
                      'DevCare Solutions, Ltd. and Client, and their respective affiliates and all of their respective
                      officers and employees.'
                      Contractor agrees to hold DevCare Solutions harmless for any damages or expenses, including
                      attorney’s fees, incurred as
                      a result of misconduct of Contractor or its personnel.
                    </li>
                    <br>
                    <li>12.&nbsp;BREACH Any breach of any provision of this Agreement by Contractor or its personnel entitles
                      DevCare Solutions to
                      recover from Contractor damages and injunctive relief. Contractor agrees that because monetary
                      damages are likely to be
                      inadequate, DevCare Solutions shall be entitled to temporary injunctive relief (by providing to a
                      court such breach). If
                      DevCare Solutions is successful in recovering damages or obtaining injunctive relief, Contractor
                      agrees to be responsible
                      for paying all of DevCare Solutions’ expenses in seeking such relief, including all costs of
                      bringing suit and all reasonable
                      attorneys’ fees.
                    </li>
                    <br>
                    <li>13.&nbsp;MISCELLANEOUS This Agreement and any attached Purchase Order(s) represent the entire agreement and
                      understanding of the parties and any modification thereof shall not be valid unless contained in
                      writing signed by both
                      parties. No other document, including any agreement between DevCare Solutions and the client,
                      shall be deemed to modify
                      any terms of this Agreement unless expressly stated in writing to do so and signed by both DevCare
                      Solutions and the
                      Contractor.
                      Each provision of the Agreement shall be considered severable such that if any one provision or
                      clause conflicts with
                      existing or future applicable law, or may not be given full effect because of such law, this shall
                      not affect any other provision
                      of the Agreement which can be given effect without the conflicting provision or clause. To the
                      extent that there may be a
                      conflict between the terms of this Agreement and the Purchase Order, this Agreement shall take
                      precedence. Contractor
                      represents that Contractor has read and understands the terms of this Agreement, has had an
                      opportunity to ask any
                      questions and to seek the assistance of legal counsel regarding these terms, and is not relying
                      upon any advice from
                      DevCare Solutions in this regard.
                      This Agreement shall be governed by the laws of the State of Ohio, except for its choice of law
                      principles, regardless of
                      where Contractor’s work is performed, and any litigation shall be brought in the state or federal
                      courts of the State of Ohio.
                      Contractor agrees to the exclusive jurisdiction of the federal and state courts located in the
                      Franklin County, in the State of
                      Ohio, for any and all disputes arising under the agreement, to the exclusion of all other federal
                      and state courts.

                    </li>
                    <br>
                 
                    <div class="row">
                      <div class="col-md-4">
                        <form>
                          <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12">
                              <label></label>
                              <input class="form-control" value="DevCare Solutions, Ltd." pInputText style="pointer-events: none;">
                            </div>
                            <div class="p-field p-col-12">
                              <label>Name</label>
                              <input class="form-control" value="" pInputText style="pointer-events: none;">
                            </div>
                            <div class="p-field p-col-12">
                              <label>Title</label>
                              <input class="form-control" value="" pInputText style="pointer-events: none;">
                              
                            </div>

                            <div class="p-field p-col-12">
                              <label>Signature</label><br>
                              <img style="margin-top:30px;" />
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-md-4"></div>
                      <div class="col-md-4 rightcol">
                        <form [formGroup]="signForm">
                          <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12">
                              <label>Vendor Name</label>
                              <input class="form-control" [(ngModel)]="vendorNameOnMSADoc" formControlName="vendorName"pInputText style="pointer-events: none;">
                              
                            </div>
                          <div class="p-field p-col-12">
                            <label>Name</label>
                            <input class="form-control"  maxlength="100" formControlName="name" pInputText>
                            
                          </div>
                          <div class="p-field p-col-12">
                            <label>Title</label>
                            <input class="form-control" formControlName="title" pInputText>
                            
                          </div>
                          <!-- <div class="p-field p-col-12">
                            <button type="button" class="btn btn-primary" (click)="openSignatureTab()">Draw</button>&nbsp;&nbsp;
                            <button type="button" class="btn btn-primary" (click)="openTextTab()">Type</button>&nbsp;&nbsp;
                            <button type="button" class="btn btn-primary" (click)="openImageUploadTab(); imageUpload.click()">Image</button>

                          </div> -->
                          <div class="p-field p-col-12">
                            <label>Signature</label>
                          <p-tabView (onChange)="handleChange($event)">
                            <p-tabPanel header="Draw">
                              <ng-template pTemplate = "header">
                                <i style="font-size:13px;" class="fas fa-pen"></i>&nbsp;
                                <span style="font-size:13px;">Draw</span>
                            </ng-template>
                              <canvas #canvas class="canva" style="border: 1px dotted  #B6B2B2"></canvas>
                              <br /><br>
                              <div class="d-flex justify-content-between">
                                <div>
                                  <button pButton pRipple type="button" class="p-button-text" (click)="clear()">Clear</button>
                                </div>
                                <div>
                                  <button pButton pRipple type="button" class="p-button-text" (click)="undo()">Undo</button>
                                </div>
                              </div>
                            </p-tabPanel>
                            <p-tabPanel header="Type">
                              <ng-template pTemplate = "header">
                                <i style="font-size:13px;" class="far fa-keyboard"></i>&nbsp;
                                <span style="font-size:13px;">Type</span>
                            </ng-template>
                              <!-- <p-editor formControlName="text2">
                                <ng-template pTemplate="header">
                                     <span class="ql-formats">
                                       
                                      </span> 
                                </ng-template>
                            </p-editor> -->
                            <div class="p-field p-col-12">
                              <input  class="form-control textToImage"  formControlName="signText" pInputText style="font-size: 28px !important;">
                            </div>
                            </p-tabPanel>
                            <p-tabPanel header="Image">
                              <ng-template pTemplate = "header">
                                <i style="font-size:13px;" class="far fa-image"></i>&nbsp;
                                <span style="font-size:13px;">Image</span>
                            </ng-template>
                              <div class="image-upload1">
                                <button pButton pRipple type="button" label="Select Image" class="p-button-outlined" (click)="imageUpload.click()" *ngIf="!imageUrl"></button>
                                <br />
                                <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #imageUpload
                                (change) = "onImageSelect($event,$event.target.files)" (click)="$event.target.value=null" hidden/>
                                <img *ngIf="imageUrl" [src]="imageUrl" class="image" width="300" height="75">
                                <br />
                                <div class="d-flex justify-content-between">
                                  <div>
                                  <button pButton pRipple type="button" class="p-button-text" (click)="imageUrl = ''" *ngIf="imageUrl">Clear</button>
                                  </div>
                                </div>
                              </div>
                            </p-tabPanel>
                        </p-tabView>
                      </div>
                          <!-- <div class="p-field p-col-12" [hidden]="!isSignatureTab">
                            <label>Signature</label>

                            <canvas #canvas class="canva" style="border-bottom: 1px solid #B6B2B2"></canvas>
                            <br /><br>
                            
                            <div class="d-flex justify-content-between">
                              <button type="button" class="btn btn-primary" (click)="clear()">Clear</button>
                              <button type="button" class="btn btn-primary" (click)="undo()">Undo</button>

                            </div>
                            
                          </div> -->
                          <!-- <div class="p-field p-col-12" *ngIf="isTextTab">
                            <label>Text</label>
                            <p-editor formControlName="text2">
                              <ng-template pTemplate="header">
                                   <span class="ql-formats">
                                       <button type="button" class="ql-bold" aria-label="Bold"></button>
                                      <button type="button" class="ql-italic" aria-label="Italic"></button>
                                      <button type="button" class="ql-underline" aria-label="Underline"></button>
                                     
                                    </span> 
                              </ng-template>
                          </p-editor>
                          <div #text2Container ></div>
                            <br /><br>
                           
                            <div class="d-flex justify-content-between">
                            

                            </div>
                            
                          </div> -->
                          <!-- <div class="p-field p-col-12" [hidden]="!isImageUploadTab">
                            <label>Image Upload</label>
                            <div class="image-upload1">
                              <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #imageUpload
                              (change) = "onImageSelect($event,$event.target.files)" (click)="$event.target.value=null" hidden/>
                              <img *ngIf="imageUrl" [src]="imageUrl" class="image" >
                            </div>
                          </div> -->
                          </div>
                        </form>
                      </div>
                    </div>
                    <br><br><br>
                    <div class="row" style="font-size: 11px;">
                      <div class="col-md-6">
                       <span>DevCare Solutions, Ltd. </span>
                      </div>
                      <div class="col-md-6" style="text-align:right;">
                        Page 3 of 3
                       </div>
                     </div>
                  </ul>
                </div>
              </div>
              
              <div class="d-flex justify-content-end" style="margin-top:25px;margin-bottom:15px;">
                <button pButton pRipple type="button" [disabled]="!showMSAFormFilePreviewEnable" (click)="ShowMSAUploadedFile()" label="Preview" icon="pi pi-eye" class="btn btn-primary"></button>&nbsp;
                <button type="submit" class="btn btn-primary" [disabled]="!signForm.valid
                || (registerProfileFormControl.taxIdNumber.touched) && registerProfileFormControl.taxIdNumber.errors?.required
                || (registerProfileFormControl.vendorName.touched) && registerProfileFormControl.vendorName.errors?.required || (this.addressOnMSADoc== undefined || this.addressOnMSADoc== null|| this.addressOnMSADoc=='') ||
                (this.cityOnMSADoc == undefined || this.cityOnMSADoc== null|| this.cityOnMSADoc=='')||
                (this.stateOnMSADoc == undefined|| this.stateOnMSADoc== null|| this.stateOnMSADoc=='') ||
                (this.zipCodeOnMSADoc== undefined|| this.zipCodeOnMSADoc== null|| this.zipCodeOnMSADoc== '') || isPaymentTermsEnable"
                  (click)="pdf()">Generate</button>&nbsp;
              </div>
            </div>

          </p-accordionTab>
      </p-accordion>

        <p-accordion>
          <p-accordionTab header="Client Selection / Onboarding Documents" [selected]="false">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-6">
                    <label>Please select your vendor category<span
                        class="required-field">*</span></label>
                        <p-dropdown (onChange)="getClientListForRegistrationOnChange($event)" [options]="clientListForRegistration" placeholder="Select"
                        optionLabel="description" [(ngModel)]="selectedClientRegistrationId" [ngModelOptions]="{standalone: true}">
                      </p-dropdown>
                    <!-- <p-multiSelect [options]="clientNameList" (onChange)="getClientOnChange($event)"
                      optionLabel="companyName" [(ngModel)]="CliIds" [ngModelOptions]="{standalone: true}"
                      defaultLabel={{selectedClientItems}} display="chip"></p-multiSelect> -->
                  </div>
                  <div class="p-field p-col-12 p-md-6">
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-field p-col-5 p-md-5"></div>
                      <div class="p-field p-col-5 p-md-5">
                        <label>Certificate of Insurance 
                          <!-- <span *ngIf="!forIndividual" class="required-field">*</span> -->
                        </label>
                      </div>
                      <div class="p-field p-col-6 p-md-2">
                        <button pButton pRipple type="button" class="p-button-outlined p-button-sm"
                          [icon]="isShowCertificateofInsurance === true ? 'pi pi-minus' : 'pi pi-plus'"
                          (click)="isShowCertificateofInsurance = !isShowCertificateofInsurance"></button>
                      </div>
                    </div>
                  </div>
                 
                </div>
                <!--starts-->
                <!-- <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-6 p-md-3">
                    <label>Certificate of Insurance</label>
                  </div>
                  <div class="p-field p-col-6 p-md-2">
                    <button pButton pRipple type="button" class="p-button-outlined p-button-sm"
                      [icon]="isShowCertificateofInsurance === true ? 'pi pi-minus' : 'pi pi-plus'"
                      (click)="isShowCertificateofInsurance = !isShowCertificateofInsurance"></button>
                  </div>
                  <div class="p-field p-col-6 p-md-7"></div>
                </div> -->
                <div class="row"  *ngIf="isShowCertificateofInsurance">
                  <div class="col-md-1"></div>
                  <div class="col-md-10">
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-field p-col-12 p-md-12">
                        <span class="text-center"><u>Certification of Insurance (DevCare Clients)</u></span>
                      </div>
                    </div>
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-field p-col-12 p-md-4">
                        <div class="p-text-bold">Client Name</div>
                        <div class="p-mb-3 p-text-normal">DevCare Clients</div>
                      </div>
                      <div class="p-field p-col-12 p-md-4">
                        <div class="p-text-bold">Client Address</div>
                        <div class="p-text-normal">579 Executive Campus Drive,</div>
                        <div class="p-text-normal">Suite 370 • Westerville,</div>
                        <div class="p-text-normal">OH – 43082</div>
                      </div>
                      <div class="p-field p-col-12 p-md-4">
                        <div class="p-text-bold">Certificate Holder</div>
                        <div class="p-text-normal">DevCare Solutions Ltd</div>
                        <div class="p-text-normal">579 Executive Campus Drive,</div>
                        <div class="p-text-normal">Suite 370 • Westerville,</div>
                        <div class="p-text-normal">OH – 43082</div>
                      </div>
                    </div>
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-field p-col-12 p-md-12">
                        <div class="p-text-bold">Additional Insured Section</div>
                        <div class="p-mb-3 p-text-normal">Certificate Holder is named as Additional Insured as their
                          interests may appear in regards to general liability</div>
                      </div>
                    </div>
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-field p-col-12 p-md-12">
                        <div class="p-text-bold">Insurance Requirements</div>
                        <div class="p-mb-3 p-text-normal">Please provide a certificate of insurance, with expiration dates
                          at least 30 days from today’s date, with the following coverage levels</div>
                      </div>
                    </div>
                    <div>
                      <table class="table table-responsive ">
                        <thead>
                          <tr>
                            <th>Type of Insurance</th>
                            <th>Limit</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td rowspan="6">Commercial General Liability (General aggregate limit applier per policy)</td>
                            <td>Each Occurrence</td>
                            <td>$1,000,000</td>
                          </tr>
                          <tr>
                            <td>Damage to rental premises (Each occurrence)</td>
                            <td>$300,000</td>
                          </tr>
                          <tr>
                            <td>Medical Expense (Any one person)</td>
                            <td>$10,000</td>
                          </tr>
                          <tr>
                            <td>Personal & ADV Injury</td>
                            <td>$1,000,000</td>
                          </tr>
                          <tr>
                            <td>General aggregate</td>
                            <td>$2,000,000</td>
                          </tr>
                          <tr>
                            <td>Products – Comp/OP Agg</td>
                            <td>$2,000,000</td>
                          </tr>
                          <tr>
                            <td>Automobile Liability (Hired & Non-owned Autos)</td>
                            <td>Combined Single Limit (Each accident)</td>
                            <td>$1,000,000</td>
                          </tr>
                          <tr>
                            <td rowspan="2">Umbrella Liability</td>
                            <td>Each occurrence</td>
                            <td>$5,000,000</td>
                          </tr>
                          <tr>
                            <td>Aggregate</td>
                            <td>$5,000,000</td>
                          </tr>
                          <tr>
                            <td rowspan="3">Worker’s compensation and employer’s liability</td>
                            <td>EL Each accident</td>
                            <td>$1,000,000</td>
                          </tr>
                          <tr>
                            <td>EL Disease – EA Employee</td>
                            <td>$1,000,000</td>
                          </tr>
                          <tr>
                            <td>EL Disease – Policy limit</td>
                            <td>$1,000,000</td>
                          </tr>
                          <tr>
                            <td>Professional Liability - Errors & Omissions</td>
                            <td>Occurrence /
                              Aggregate</td>
                            <td>$5,000,000/
                              $5,000,000</td>
                          </tr>
                          <tr>
                            <td>Fidelity Bond 3rd party BKT</td>
                            <td>Each occurrence</td>
                            <td>$2,000,000</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-md-1"></div>
                </div>
                <div *ngIf="isShowCertificateofInsurance">                 
                  <!--starts-->
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-3">
                      <label> General Liability Eff Date 
                        <!-- <span *ngIf="!forIndividual"
                          class="required-field">*</span> -->
                        </label>
                      <p-calendar [showIcon]="true" type="date" [maxDate]="minExpDate" formControlName="glEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                      </p-calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <label>General Liability Exp Date
                        <!-- <span *ngIf="!forIndividual"
                          class="required-field">*</span> -->
                        </label>
                      <p-calendar [showIcon]="true" type="date" [minDate]="minExpDate" formControlName="glExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                      </p-calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <label> Automobile Liability Eff Date
                         <!-- <span *ngIf="!forIndividual"
                          class="required-field">*</span> -->
                        </label>
                      <p-calendar [showIcon]="true" type="date" [maxDate]="minExpDate" formControlName="alEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                      </p-calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <label>Automobile Liability Exp Date
                        <!-- <span *ngIf="!forIndividual"
                          class="required-field">*</span> -->
                        </label>
                      <p-calendar [showIcon]="true" type="date" [minDate]="minExpDate" formControlName="alExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                      </p-calendar>
                    </div>
                  </div>
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-3">
                      <label> Umbrella Liability Eff Date
                        <!-- <span *ngIf="!forIndividual"
                          class="required-field">*</span> -->
                        </label>
                      <p-calendar [showIcon]="true" type="date" [maxDate]="minExpDate" formControlName="ulEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                      </p-calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <label>Umbrella Liability Exp Date
                        <!-- <span *ngIf="!forIndividual"
                          class="required-field">*</span> -->
                        </label>
                      <p-calendar [showIcon]="true" type="date" [minDate]="minExpDate" formControlName="ulExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                      </p-calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <label> Workers Compensation Eff Date 
                        <!-- <span *ngIf="!forIndividual"
                          class="required-field">*</span> -->
                        </label>
                      <p-calendar [showIcon]="true" type="date" [maxDate]="minExpDate" formControlName="wcEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                      </p-calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <label>Workers Compensation Exp Date
                        <!-- <span *ngIf="!forIndividual"
                          class="required-field">*</span> -->
                        </label>
                      <p-calendar [showIcon]="true" type="date" [minDate]="minExpDate" formControlName="wcExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                      </p-calendar>
                    </div>
                  </div>
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-3">
                      <label> Professional Liability Eff Date
                         <!-- <span *ngIf="!forIndividual"
                          class="required-field">*</span> -->
                        </label>
                      <p-calendar [showIcon]="true" type="date" [maxDate]="minExpDate" formControlName="plEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                      </p-calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <label>Professional Liability Exp Date
                        <!-- <span *ngIf="!forIndividual"
                          class="required-field">*</span> -->
                        </label>
                      <p-calendar [showIcon]="true" type="date" [minDate]="minExpDate" formControlName="plExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                      </p-calendar>
                    </div>
                  </div>
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                      <label>Comments</label>
                      <br>
                      <textarea formControlName="comments" maxlength="1000" pInputTextarea
                        class="form-control"></textarea>
                    </div>
                  </div>

                </div>
                <!--ends-->
                <div class="card">
                  <div class="card-body">
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-field p-col-12 col-md-6 col-sm-6 col-lg-6">
                        <div class="card">
                          <div class="card-header">
                            <label>COI Form
                              <!-- <span *ngIf="!forIndividual" class="required-field">*</span> -->
                            </label>
                            <button pButton pRipple [disabled]="!showCOIFormFilePreviewEnable" type="button" icon="pi pi-eye" (click)="ShowInsuranceUploadedFile()"
                              class="p-button-raised" style="float: right;border-radius: 50%;height: 30px;"></button>
                          </div>
                          <div class="card-body  text-center" style="height: 70px;">
                            <div class="vms-file-upload">
                              <input type='file' id="InsuranceUpload" (change)="onInsuranceSelect($event)"
                                style="display: none;" accept=".doc, .docx, .pdf,.xls,.xlsx,.Pdf,.PDF" #InsuranceUpload />
                              <div>
                                <button pButton pRipple type="button" label="Upload" icon="pi pi-upload"
                                  class="p-button-raised" style="width: fit-content;height: 30px;"
                                  (click)="InsuranceUpload.click()"></button><br /> <br />
                              </div>
                            </div>
                          </div>
                          <div class="card-footer">
                            <small class="text-sm"
                              [ngClass]="isInsurancefileShowsuccessmsg == true ? 'label-success': 'label-error'">{{Insurancefileuploadmessage}}</small>
                            <!-- <small class="text-bold text-sm text-primary"  [ngClass]="isInsurancefileShowsuccessmsg == true ? 'label-success': 'label-error'">
                            {{Insurancefileuploadmessage}}
                          </small> -->
                          </div>
                        </div>
                      </div>
                      <div class="p-field p-col-12 col-md-6 col-sm-6 col-lg-6">
                        <div class="card">
                          <div class="card-header">
                            <label>W9 Form
                              <!-- <span *ngIf="!forIndividual" class="required-field">*</span> -->
                            </label>
                            <button pButton pRipple type="button" [disabled]="!showW9FormFilePreviewEnable" (click)="Showw9UploadedFile()" icon="pi pi-eye"
                              class="p-button-raised" style="float: right;border-radius: 50%;height: 30px;"></button>
                          </div>
                          <div class="card-body  text-center" style="height: 70px;">
                            <div class="vms-file-upload">
                              <input type='file' id="W9FormUpload" (change)="onW9FormSelect($event)"
                                style="display: none;" accept=".doc, .docx, .pdf,.xls,.xlsx,.Pdf,.PDF" #W9FormUpload />
                              <div>
                                <button pButton pRipple type="button" icon="pi pi-upload" label="Upload"
                                  class="p-button-raised" style="width: fit-content;height: 30px;"
                                  (click)="W9FormUpload.click()"></button><br /> <br />
                              </div>
                            </div>
                          </div>
                          <div class="card-footer">
                            <small class="text-sm"
                              [ngClass]="isw9fileShowsuccessmsg== true ? 'label-success': 'label-error'">{{w9fileuploadmessage}}</small>

                          </div>
                        </div>
                      </div>
                      <div class="p-field p-col-12 col-md-6 col-sm-6 col-lg-6">
                        <div class="card">
                          <div class="card-header">
                            <label>DD Authorization
                              <!-- <span *ngIf="!forIndividual" class="required-field">*</span> -->
                            </label>
                            <button pButton pRipple type="button"  [disabled]="!showDDFormFilePreviewEnable" (click)="ShowDDAuthorizationUploadedFile()"
                              icon="pi pi-eye" class="p-button-raised"
                              style="float: right;border-radius: 50%;height: 30px;"></button>
                          </div>
                          <div class="card-body  text-center" style="height: 70px;">
                            <div class="vms-file-upload">
                              <input type='file' id="DDAutorizationUpload" (change)="onDDAutorizationSelect($event)"
                                style="display: none;" accept=".doc, .docx, .pdf,.xls,.xlsx,.Pdf,.PDF" #DDAutorizationUpload />
                              <div>
                                <button pButton pRipple type="button" icon="pi pi-upload" label="Upload"
                                  class="p-button-raised" style="width: fit-content;height: 30px;"
                                  (click)="DDAutorizationUpload.click()"></button><br /> <br />
                              </div>
                            </div>
                          </div>
                          <div class="card-footer">
                            <small class="text-sm"
                              [ngClass]="isDDfileShowsuccessmsg== true ? 'label-success': 'label-error'">{{DDfileuploadmessage}}</small>

                          </div>
                        </div>
                      </div>
                      <!-- <div class="p-field p-col-12 col-md-3 col-sm-3 col-lg-3">
                      <div class="card">
                        <div class="card-header">
                          <label><a href="../../../../assets/pdf/MSA.pdf" target="_blank">Download MSA</a></label>
                          <button pButton pRipple type="button" (click)="ShowMSAUploadedFile()" icon="pi pi-eye"
                          class="p-button-raised"  style="float: right;border-radius: 50%;height: 30px;"></button>
                        </div>
                        <div class="card-body  text-center" style="height: 70px;">
                          <div class="vms-file-upload">
                            <input type='file' id="MSAUpload" (change)="onMSASelect($event)" style="display: none;"
                              accept=".pdf" #MSAUpload />
                            <div>
                              <button pButton pRipple type="button" label="Upload" icon="pi pi-upload" class="p-button-raised"
                                style="width: fit-content;height: 30px;" (click)="MSAUpload.click()"></button><br /> <br />
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <small class="text-bold text-sm text-primary"
                            [ngClass]="isInsurancefileShowsuccessmsg == true ? 'label-success': 'label-error'">{{MSAfileuploadmessage}}</small>
                        </div>
                      </div>
                    </div> -->
                    <div class="p-field p-col-12 col-md-6 col-sm-6 col-lg-6">
                      <!-- <div class="card">
                        <div class="card-header" style="height: 49px;">
                          <label>Master Service Agreement <span *ngIf="!forIndividual" class="required-field">*</span> &nbsp;&nbsp;</label>
                          <img src="../../../../assets/img/exclamatoryFinal.png" width="20px" height="20px" hideDelay="5000" pTooltip="{{msaTooltipMsg}}" tooltipPosition="top"> -->
                          <!-- <button pButton pRipple type="button" hideDelay="10000" pTooltip="{{msaTooltipMsg}}" tooltipPosition="right" icon="pi pi-exclamation-circle" class="p-button-rounded p-button-warning"></button> -->
                          <!-- <div class="p-d-flex p-jc-between" style="float: right;">
                            <a href="../../../../assets/pdf/MSA.pdf" target="_blank">
                              <button pButton pRipple type="button" label="Secondary" class="p-button-raised p-button-secondary" style="width: fit-content;height:30px;float:right;" icon="pi pi-download" label="MSA"></button>                          
                            </a> &nbsp;&nbsp;
                            <button pButton pRipple type="button"  [disabled]="!showMSAFormFilePreviewEnable" (click)="ShowMSAUploadedFile()" icon="pi pi-eye"
                          class="p-button-raised" style="float: right;border-radius: 50%;height: 30px;"></button>                         
                          </div>
                        </div> -->
                        <!-- <div class="card-body text-center" style="height: 75px;"> -->
                          <!-- <small class="form-text text-muted" style="font-size: 15px;">This document requires your
                            signature.Please download the given
                            document,complete the necessary information, sign it, and upload it back to us</small> -->
                          <!-- <p-divider></p-divider> -->
                          <!-- <div class="vms-file-upload">
                            <input type='file' id="MSAUpload" (change)="onMSASelect($event)" style="display: none;"
                              accept=".doc, .docx, .pdf,.xls,.xlsx" #MSAUpload />
                            <div class="text-center">
                              <button pButton pRipple type="button" label="Upload" icon="pi pi-upload" class="p-button-raised"
                                style="width: fit-content;height: 30px;" (click)="MSAUpload.click()"></button><br /> <br />
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <small class="text-sm"
                            [ngClass]="isMSAfileShowsuccessmsg== true ? 'label-success': 'label-error'">{{MSAfileuploadmessage}}</small>                         
                        </div>
                      </div>-->
                    </div> 
                    </div>
                  </div>
                  <!-- <div class="card-footer">
                  <label>Master Service Agreement (MSA)<span *ngIf="!forIndividual" class="required-field">*</span></label>
                  <label class="border border-info p-p-1 bg-secondary" style="float: right;border-radius: 5px;"><a href="../../../../assets/pdf/MSA.pdf" target="_blank">Download MSA</a></label>
                <small class="form-text text-muted" style="font-size: 14px;">This document requires your signature.Please download the given
                  document,complete the necessary information, sign it, and upload it back to us</small>
                 </div> -->
                </div>                

              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
       
      </div>
      <div class="col-md-1">

      </div>
    </div>
  </form>
</section>
<section>
  <div class="row">
    <div class="col-lg-2"></div>
    <div class="col-lg-8">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-12">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-4"><button class="bg-success" pButton pRipple type="button"
                [disabled]="!isSaveAvailable ||  !loadClient || vendorNameAvail || taxIdAvail|| vendorEmailAvail || adminEmailAvail || isSqlComments || entityTypeEnable
             || registerProfileFormControl.vendorEmailId.errors?.required
            || registerProfileFormControl.vendorEmailId.touched && registerProfileFormControl.vendorEmailId.errors?.pattern
            || registerProfileFormControl.adminEmailId.touched && registerProfileFormControl.adminEmailId.errors?.pattern
            || (registerProfileFormControl.taxIdNumber.touched) && registerProfileFormControl.taxIdNumber.errors?.required || isOwnerPhoneUniqueNumbers || isOwnerAlternatePhoneUniqueNumbers || isRecruitingPhoneUniqueNumbers ||
            isRecruitingAlternatePhoneUniqueNumbers || isAccountingPhoneUniqueNumbers || isAccountingAlternatePhoneUniqueNumbers ||
            isFinancialPhoneUniqueNumbers || isFinancialAlternatePhoneUniqueNumbers || isOwnerPhoneNumberValid || isOwnerAlternatePhoneNumberValid ||
            isRecruitingPhoneNumberValid || isRecruitingAlternatePhoneNumberValid || isAccountingPhoneNumberValid || isAccountingAlternatePhoneNumberValid 
           || isFinancialPhoneNumberValid || isFinancialAlternatePhoneNumberValid || emailEntityInvalid || isVendorPhoneNumberValid || isUserPhoneNumberValid || isOnshorePhoneNumberValid || isReferencePhoneNumberValid
            ||(registerProfileFormControl.vendorName.touched) && registerProfileFormControl.vendorName.errors?.required" (click)="onSaveRegisterProfile(registerProfileForm)" label="Save"></button></div>
            <div class="p-field p-col-12 p-md-4"><button pButton pRipple type="button" [disabled]="!registerProfileForm.valid  ||  !loadClient
              || selectedCountryValid || businessCertificationValid || selectedClientValidOnRegistration || msaValid  || adminEmailAvail || isOwnerPhoneUniqueNumbers || isOwnerAlternatePhoneUniqueNumbers || isRecruitingPhoneUniqueNumbers ||
              isRecruitingAlternatePhoneUniqueNumbers || isAccountingPhoneUniqueNumbers || isAccountingAlternatePhoneUniqueNumbers ||
              isFinancialPhoneUniqueNumbers || isFinancialAlternatePhoneUniqueNumbers || isOwnerPhoneNumberValid || isOwnerAlternatePhoneNumberValid ||
              isRecruitingPhoneNumberValid || isRecruitingAlternatePhoneNumberValid || isAccountingPhoneNumberValid || isAccountingAlternatePhoneNumberValid 
             || isFinancialPhoneNumberValid || isFinancialAlternatePhoneNumberValid || emailEntityInvalid ||isPaymentTermsEnable|| isVendorPhoneNumberValid || isUserPhoneNumberValid"
                (click)="onSubmitRegisterProfile(registerProfileForm)" label="Submit"></button></div>
            <div class="p-field p-col-12 p-md-4"><button class="bg-danger" pButton pRipple type="button"
                (click)="onCancelRegisterProfile()" label="Cancel"></button></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-2"></div>
  </div>
</section>
<!--<section>
  <p-dialog header="File Preview" [(visible)]="showPreview" [modal]="true" [style]="{width: '60vw'}" [draggable]="false"
    [resizable]="false">
    <div class="col-md-12">
      <div style="min-height: 50vmax;">
        <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="true">
        </pdf-viewer>
      </div>
    </div>
  </p-dialog>
</section>
<section>
  <p-dialog header="File Preview" [(visible)]="showDDPreview" [modal]="true" [style]="{width: '60vw'}"
    [draggable]="false" [resizable]="false">
    <div class="col-md-12">
      <div style="min-height: 50vmax;">
        <pdf-viewer [src]="DDpdfSrc" [render-text]="true" [original-size]="true">
        </pdf-viewer>
      </div>
    </div>
  </p-dialog>
</section>
<section>
  <p-dialog header="MSA File Preview" [(visible)]="showMSAPreview" [modal]="true" [style]="{width: '60vw'}"
    [draggable]="false" [resizable]="false">
    <div class="col-md-12">
      <div style="min-height: 50vmax;">
        <pdf-viewer [src]="MSApdfSrc" [render-text]="true" [original-size]="true">
        </pdf-viewer>
      </div>
    </div>
  </p-dialog>
</section>
<section>
  <p-dialog header="Insurance File Preview" [(visible)]="showInsurancePreview" [modal]="true" [style]="{width: '60vw'}"
    [draggable]="false" [resizable]="false">
    <div class="col-md-12">
      <div style="min-height: 50vmax;">
        <pdf-viewer [src]="InsurancepdfSrc" [render-text]="true" [original-size]="true">
        </pdf-viewer>
      </div>
    </div>
  </p-dialog>
</section>-->

<p-toast [baseZIndex]="100001" position="bottom-center" key="w9"></p-toast>
<!-- <p-dialog  [(visible)]="showPreview" [modal]="true" [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}"
[draggable]="false" [resizable]="false">
<p-toast position="bottom-center" key="w9"></p-toast>
<ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a [download]="w9FileDisplayName" target="_blank" [href]="w9FileDocUrl" *ngIf="showW9FormFilePreviewEnable"><i class="fa fa-download" aria-hidden="true"></i></a></span>
</ng-template>
  <br>
  <div class="card p-p-2">
      <div class="card-header">
      </div>     
      <div class="card-footer">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
            <div class="p-field p-col-2 col-md-2 col-sm-2">
              <p-progressSpinner  [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showW9FormFilePreview"></p-progressSpinner>
          </div>
          <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
          <div class="p-field p-col-12 col-md-12 col-sm-12">
              <ngx-doc-viewer *ngIf="showW9FormFilePreview" [url]="w9FileDocUrl" disableContent="popout"
              viewer="google" style="width:100%;height:80vh;">
          </ngx-doc-viewer>
          </div>
        </div> 
      </div>
  </div>
</p-dialog> -->

<p-toast [baseZIndex]="100001" position="bottom-center" key="dd"></p-toast>
<!-- <p-dialog  [(visible)]="showDDPreview" [modal]="true" [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}"
[draggable]="false" [resizable]="false">

<ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a [download]="ddAuthorizationFileDisplayName" target="_blank" [href]="ddFileDocUrl" *ngIf="showDDFormFilePreviewEnable"><i class="fa fa-download" aria-hidden="true"></i></a></span>
</ng-template>
  <br>
  <div class="card p-p-2">
      <div class="card-header">
      </div>     
      <div class="card-footer">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
            <div class="p-field p-col-2 col-md-2 col-sm-2">
              <p-progressSpinner  [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showDDFormFilePreview"></p-progressSpinner>
          </div>
          <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
          <div class="p-field p-col-12 col-md-12 col-sm-12">
              <ngx-doc-viewer *ngIf="showDDFormFilePreview" [url]="ddFileDocUrl" disableContent="popout"
                 viewer="google" style="width:100%;height:80vh;">
             </ngx-doc-viewer>
          </div>
        </div> 
      </div>
  </div>
</p-dialog> -->

<p-toast [baseZIndex]="100001" position="bottom-center" key="msa"></p-toast>
<!-- <p-dialog [(visible)]="showMSAPreview" [modal]="true" [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}"
[draggable]="false" [resizable]="false">

<ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a [download]="msaFileDisplayName" target="_blank" [href]="msaFileDocUrl" *ngIf="showMSAFormFilePreviewEnable"><i class="fa fa-download" aria-hidden="true"></i></a></span>
</ng-template>
  <br>
  <div class="card p-p-2">
      <div class="card-header">
      </div>     
      <div class="card-footer">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
            <div class="p-field p-col-2 col-md-2 col-sm-2">
              <p-progressSpinner  [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showMSAFormFilePreview"></p-progressSpinner>
          </div>
          <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
          <div class="p-field p-col-12 col-md-12 col-sm-12">
              <ngx-doc-viewer *ngIf="showMSAFormFilePreview" [url]="msaFileDocUrl" disableContent="popout"
                viewer="google" style="width:100%;height:80vh;">
              </ngx-doc-viewer>
          </div>
        </div> 
      </div>
  </div>
</p-dialog> -->

<p-toast [baseZIndex]="100001" position="bottom-center" key="coi"></p-toast>
<!-- <p-dialog [(visible)]="showInsurancePreview" [modal]="true" [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}"
[draggable]="false" [resizable]="false">

<ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a [download]="insuranceFileDisplayName" target="_blank" [href]="coiFileDocUrl"><i class="fa fa-download" aria-hidden="true" *ngIf="showCOIFormFilePreviewEnable"></i></a></span>
</ng-template>
  <br>
  <div class="card p-p-2">
      <div class="card-header">
      </div>     
      <div class="card-footer">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
            <div class="p-field p-col-2 col-md-2 col-sm-2">
              <p-progressSpinner  [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showCOIFormFilePreview"></p-progressSpinner>
          </div>
          <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
          <div class="p-field p-col-12 col-md-12 col-sm-12">
              <ngx-doc-viewer *ngIf="showCOIFormFilePreview" [url]="coiFileDocUrl" disableContent="popout"
                viewer="google" style="width:100%;height:80vh;">
              </ngx-doc-viewer>
          </div>
        </div> 
      </div>
  </div>
</p-dialog> -->
<p-confirmDialog header="Confirmation" [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="NO" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="YES" (click)="cd.accept()"></button>
</ng-template>
</p-confirmDialog>
<p-confirmDialog key ="businessEmail" header="Confirmation" [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" #be>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="No, I don't have a work email " (click)="be.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Yes, I have a work email" (click)="be.accept()"></button>
</ng-template>
</p-confirmDialog>
<script>

</script>